var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _g, _g2, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _g3, _g4, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComingSoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 342,
    height: 388,
    viewBox: "0 0 342 388",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3875_2346)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M137.142 307.679V318.859L251.834 252.991V241.798L137.142 307.679Z",
    fill: "url(#paint0_linear_3875_2346)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M137.182 307.679V318.859L73.375 281.682V270.543L137.182 307.679Z",
    fill: "url(#paint1_linear_3875_2346)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M137.142 320.273V331.453L251.834 265.586V254.392L137.142 320.273Z",
    fill: "url(#paint2_linear_3875_2346)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M137.182 320.273V331.453L73.375 294.29V283.137L137.182 320.273Z",
    fill: "url(#paint3_linear_3875_2346)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M73.375 270.543L137.182 307.679L251.834 241.798L187.972 204.621L73.375 270.543Z",
    fill: "url(#paint4_linear_3875_2346)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M73.375 65.8812V268.536L188.08 202.668V0L73.375 65.8812Z",
    fill: "url(#paint5_linear_3875_2346)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M137.196 113.672V294.762L239.666 235.898V54.8224L137.196 113.672Z",
    fill: "url(#paint6_linear_3875_2346)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M137.223 113.672V294.761L80.2207 261.545V80.496L137.223 113.672Z",
    fill: "url(#paint7_linear_3875_2346)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2207 80.496L137.223 113.672L239.665 54.8224L182.609 21.6057L80.2207 80.496Z",
    fill: "url(#paint8_linear_3875_2346)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M137.142 103.045V305.712L251.834 239.845V37.1769L137.142 103.045Z",
    fill: "url(#paint9_linear_3875_2346)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M73.375 65.9216L137.182 103.045L251.834 37.1769L187.972 0L73.375 65.9216Z",
    fill: "url(#paint10_linear_3875_2346)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8851 93.5214L91.1899 91.9589V95.2591L93.8851 96.8216V93.5214Z",
    fill: "url(#paint11_linear_3875_2346)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7259 95.7304L95.0308 94.1814V97.4681L97.7259 99.0306V95.7304Z",
    fill: "url(#paint12_linear_3875_2346)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3628 93.0499L90.0579 94.599V91.2989L87.3628 89.7498V93.0499Z",
    fill: "url(#paint13_linear_3875_2346)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M127.696 113.026V116.326L134.407 120.192V116.892L127.696 113.026Z",
    fill: "url(#paint14_linear_3875_2346)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M126.55 112.366L98.8579 96.3905V99.6906L126.55 115.666V112.366Z",
    fill: "url(#paint15_linear_3875_2346)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2177 89.0898L83.2261 87.3657V90.6658L86.2177 92.3899V89.0898Z",
    fill: "url(#paint16_linear_3875_2346)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8851 101.536L91.1899 99.9735V103.274L93.8851 104.836V101.536Z",
    fill: "url(#paint17_linear_3875_2346)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7259 103.745L95.0308 102.196V105.483L97.7259 107.045V103.745Z",
    fill: "url(#paint18_linear_3875_2346)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3628 101.065L90.0579 102.627V99.3134L87.3628 97.7644V101.065Z",
    fill: "url(#paint19_linear_3875_2346)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M127.696 121.04V124.341L134.407 128.22V124.906L127.696 121.04Z",
    fill: "url(#paint20_linear_3875_2346)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M126.55 120.38L98.8579 104.405V107.705L126.55 123.68V120.38Z",
    fill: "url(#paint21_linear_3875_2346)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2177 97.1044L83.2261 95.3802V98.6804L86.2177 100.405V97.1044Z",
    fill: "url(#paint22_linear_3875_2346)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8851 109.551L91.1899 107.988V111.288L93.8851 112.851V109.551Z",
    fill: "url(#paint23_linear_3875_2346)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7259 111.76L95.0308 110.211V113.511L97.7259 115.06V111.76Z",
    fill: "url(#paint24_linear_3875_2346)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3628 109.079L90.0579 110.642V107.342L87.3628 105.779V109.079Z",
    fill: "url(#paint25_linear_3875_2346)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M127.696 129.055V132.355L134.407 136.234V132.934L127.696 129.055Z",
    fill: "url(#paint26_linear_3875_2346)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M126.55 128.395L98.8579 112.42V115.72L126.55 131.695V128.395Z",
    fill: "url(#paint27_linear_3875_2346)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2177 105.119L83.2261 103.395V106.695L86.2177 108.419V105.119Z",
    fill: "url(#paint28_linear_3875_2346)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8851 117.565L91.1899 116.003V119.303L93.8851 120.865V117.565Z",
    fill: "url(#paint29_linear_3875_2346)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7259 119.774L95.0308 118.225V121.525L97.7259 123.074V119.774Z",
    fill: "url(#paint30_linear_3875_2346)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3628 117.094L90.0579 118.643V115.356L87.3628 113.794V117.094Z",
    fill: "url(#paint31_linear_3875_2346)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M127.696 137.07V140.37L134.407 144.235V140.949L127.696 137.07Z",
    fill: "url(#paint32_linear_3875_2346)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M126.55 136.41L98.8579 120.434V123.734L126.55 139.71V136.41Z",
    fill: "url(#paint33_linear_3875_2346)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2177 113.134L83.2261 111.409V114.71L86.2177 116.434V113.134Z",
    fill: "url(#paint34_linear_3875_2346)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8851 125.58L91.1899 124.017V127.317L93.8851 128.88V125.58Z",
    fill: "url(#paint35_linear_3875_2346)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7259 127.789L95.0308 126.24V129.54L97.7259 131.089V127.789Z",
    fill: "url(#paint36_linear_3875_2346)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3628 125.108L90.0579 126.657V123.371L87.3628 121.808V125.108Z",
    fill: "url(#paint37_linear_3875_2346)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M127.696 145.084V148.384L134.407 152.25V148.963L127.696 145.084Z",
    fill: "url(#paint38_linear_3875_2346)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M126.55 144.424L98.8579 128.449V131.749L126.55 147.724V144.424Z",
    fill: "url(#paint39_linear_3875_2346)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2177 121.148L83.2261 119.424V122.724L86.2177 124.448V121.148Z",
    fill: "url(#paint40_linear_3875_2346)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8851 133.594L91.1899 132.032V135.332L93.8851 136.894V133.594Z",
    fill: "url(#paint41_linear_3875_2346)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7259 135.803L95.0308 134.254V137.554L97.7259 139.103V135.803Z",
    fill: "url(#paint42_linear_3875_2346)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3628 133.123L90.0579 134.672V131.385L87.3628 129.823V133.123Z",
    fill: "url(#paint43_linear_3875_2346)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M127.696 153.099V156.399L134.407 160.265V156.978L127.696 153.099Z",
    fill: "url(#paint44_linear_3875_2346)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M126.55 152.439L98.8579 136.463V139.764L126.55 155.739V152.439Z",
    fill: "url(#paint45_linear_3875_2346)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2177 129.163L83.2261 127.439V130.739L86.2177 132.463V129.163Z",
    fill: "url(#paint46_linear_3875_2346)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8851 141.609L91.1899 140.046V143.347L93.8851 144.909V141.609Z",
    fill: "url(#paint47_linear_3875_2346)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7259 143.818L95.0308 142.269V145.569L97.7259 147.118V143.818Z",
    fill: "url(#paint48_linear_3875_2346)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3628 141.137L90.0579 142.7V139.4L87.3628 137.837V141.137Z",
    fill: "url(#paint49_linear_3875_2346)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M127.696 161.113V164.413L134.407 168.293V164.993L127.696 161.113Z",
    fill: "url(#paint50_linear_3875_2346)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M126.55 160.453L98.8579 144.478V147.778L126.55 163.753V160.453Z",
    fill: "url(#paint51_linear_3875_2346)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2177 137.177L83.2261 135.453V138.753L86.2177 140.477V137.177Z",
    fill: "url(#paint52_linear_3875_2346)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8851 149.623L91.1899 148.061V151.361L93.8851 152.924V149.623Z",
    fill: "url(#paint53_linear_3875_2346)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7259 151.833L95.0308 150.284V153.584L97.7259 155.133V151.833Z",
    fill: "url(#paint54_linear_3875_2346)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3628 149.152L90.0579 150.715V147.414L87.3628 145.852V149.152Z",
    fill: "url(#paint55_linear_3875_2346)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M127.696 169.128V172.428L134.407 176.307V173.007L127.696 169.128Z",
    fill: "url(#paint56_linear_3875_2346)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M126.55 168.468L98.8579 152.493V155.793L126.55 171.768V168.468Z",
    fill: "url(#paint57_linear_3875_2346)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2177 145.192L83.2261 143.468V146.768L86.2177 148.492V145.192Z",
    fill: "url(#paint58_linear_3875_2346)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8851 157.638L91.1899 156.076V159.376L93.8851 160.938V157.638Z",
    fill: "url(#paint59_linear_3875_2346)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7259 159.847L95.0308 158.298V161.598L97.7259 163.147V159.847Z",
    fill: "url(#paint60_linear_3875_2346)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3628 157.167L90.0579 158.729V155.429L87.3628 153.866V157.167Z",
    fill: "url(#paint61_linear_3875_2346)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M127.696 177.142V180.443L134.407 184.322V181.022L127.696 177.142Z",
    fill: "url(#paint62_linear_3875_2346)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M126.55 176.482L98.8579 160.507V163.807L126.55 179.783V176.482Z",
    fill: "url(#paint63_linear_3875_2346)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2177 153.206L83.2261 151.482V154.782L86.2177 156.507V153.206Z",
    fill: "url(#paint64_linear_3875_2346)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8851 165.653L91.1899 164.09V167.39L93.8851 168.953V165.653Z",
    fill: "url(#paint65_linear_3875_2346)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7259 167.862L95.0308 166.313V169.613L97.7259 171.162V167.862Z",
    fill: "url(#paint66_linear_3875_2346)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3628 165.181L90.0579 166.744V163.444L87.3628 161.881V165.181Z",
    fill: "url(#paint67_linear_3875_2346)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M127.696 185.157V188.457L134.407 192.336V189.036L127.696 185.157Z",
    fill: "url(#paint68_linear_3875_2346)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M126.55 184.497L98.8579 168.522V171.822L126.55 187.797V184.497Z",
    fill: "url(#paint69_linear_3875_2346)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2177 161.221L83.2261 159.497V162.797L86.2177 164.521V161.221Z",
    fill: "url(#paint70_linear_3875_2346)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8851 173.667L91.1899 172.105V175.405L93.8851 176.967V173.667Z",
    fill: "url(#paint71_linear_3875_2346)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7259 175.876L95.0308 174.327V177.627L97.7259 179.176V175.876Z",
    fill: "url(#paint72_linear_3875_2346)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3628 173.196L90.0579 174.758V171.458L87.3628 169.896V173.196Z",
    fill: "url(#paint73_linear_3875_2346)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M127.696 193.172V196.472L134.407 200.351V197.051L127.696 193.172Z",
    fill: "url(#paint74_linear_3875_2346)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M126.55 192.512L98.8579 176.536V179.836L126.55 195.812V192.512Z",
    fill: "url(#paint75_linear_3875_2346)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2177 169.236L83.2261 167.511V170.812L86.2177 172.536V169.236Z",
    fill: "url(#paint76_linear_3875_2346)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8851 181.682L91.1899 180.133V183.433L93.8851 184.982V181.682Z",
    fill: "url(#paint77_linear_3875_2346)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7259 183.891L95.0308 182.342V185.642L97.7259 187.191V183.891Z",
    fill: "url(#paint78_linear_3875_2346)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3628 181.21L90.0579 182.773V179.473L87.3628 177.91V181.21Z",
    fill: "url(#paint79_linear_3875_2346)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M127.696 201.186V204.486L134.407 208.366V205.065L127.696 201.186Z",
    fill: "url(#paint80_linear_3875_2346)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M126.55 200.526L98.8579 184.551V187.851L126.55 203.826V200.526Z",
    fill: "url(#paint81_linear_3875_2346)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2177 177.25L83.2261 175.526V178.826L86.2177 180.55V177.25Z",
    fill: "url(#paint82_linear_3875_2346)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8851 189.696L91.1899 188.147V191.447L93.8851 192.997V189.696Z",
    fill: "url(#paint83_linear_3875_2346)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7259 191.905L95.0308 190.356V193.657L97.7259 195.206V191.905Z",
    fill: "url(#paint84_linear_3875_2346)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3628 189.225L90.0579 190.787V187.487L87.3628 185.925V189.225Z",
    fill: "url(#paint85_linear_3875_2346)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M127.696 209.201V212.501L134.407 216.38V213.08L127.696 209.201Z",
    fill: "url(#paint86_linear_3875_2346)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M126.55 208.541L98.8579 192.565V195.866L126.55 211.841V208.541Z",
    fill: "url(#paint87_linear_3875_2346)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2177 185.265L83.2261 183.541V186.841L86.2177 188.565V185.265Z",
    fill: "url(#paint88_linear_3875_2346)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8851 197.711L91.1899 196.162V199.449L93.8851 201.011V197.711Z",
    fill: "url(#paint89_linear_3875_2346)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7259 199.92L95.0308 198.371V201.671L97.7259 203.22V199.92Z",
    fill: "url(#paint90_linear_3875_2346)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3628 197.24L90.0579 198.802V195.502L87.3628 193.939V197.24Z",
    fill: "url(#paint91_linear_3875_2346)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M127.696 217.215V220.515L134.407 224.395V221.095L127.696 217.215Z",
    fill: "url(#paint92_linear_3875_2346)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M126.55 216.555L98.8579 200.58V203.88L126.55 219.855V216.555Z",
    fill: "url(#paint93_linear_3875_2346)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2177 193.279L83.2261 191.555V194.855L86.2177 196.579V193.279Z",
    fill: "url(#paint94_linear_3875_2346)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8851 205.726L91.1899 204.177V207.477L93.8851 209.026V205.726Z",
    fill: "url(#paint95_linear_3875_2346)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7259 207.935L95.0308 206.386V209.686L97.7259 211.235V207.935Z",
    fill: "url(#paint96_linear_3875_2346)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3628 205.254L90.0579 206.817V203.516L87.3628 201.954V205.254Z",
    fill: "url(#paint97_linear_3875_2346)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M127.696 225.23V228.53L134.407 232.409V229.109L127.696 225.23Z",
    fill: "url(#paint98_linear_3875_2346)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M126.55 224.57L98.8579 208.595V211.895L126.55 227.87V224.57Z",
    fill: "url(#paint99_linear_3875_2346)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2177 201.294L83.2261 199.57V202.87L86.2177 204.594V201.294Z",
    fill: "url(#paint100_linear_3875_2346)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8851 213.74L91.1899 212.191V215.491L93.8851 217.04V213.74Z",
    fill: "url(#paint101_linear_3875_2346)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7259 215.949L95.0308 214.4V217.7L97.7259 219.249V215.949Z",
    fill: "url(#paint102_linear_3875_2346)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3628 213.269L90.0579 214.831V211.531L87.3628 209.969V213.269Z",
    fill: "url(#paint103_linear_3875_2346)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M127.696 233.245V236.545L134.407 240.424V237.124L127.696 233.245Z",
    fill: "url(#paint104_linear_3875_2346)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M126.55 232.598L98.8579 216.609V219.909L126.55 235.885V232.598Z",
    fill: "url(#paint105_linear_3875_2346)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2177 209.308L83.2261 207.584V210.884L86.2177 212.609V209.308Z",
    fill: "url(#paint106_linear_3875_2346)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8851 221.755L91.1899 220.206V223.506L93.8851 225.055V221.755Z",
    fill: "url(#paint107_linear_3875_2346)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7259 223.964L95.0308 222.415V225.715L97.7259 227.264V223.964Z",
    fill: "url(#paint108_linear_3875_2346)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3628 221.283L90.0579 222.846V219.546L87.3628 217.983V221.283Z",
    fill: "url(#paint109_linear_3875_2346)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M127.696 241.259V244.559L134.407 248.439V245.138L127.696 241.259Z",
    fill: "url(#paint110_linear_3875_2346)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M126.55 240.613L98.8579 224.624V227.924L126.55 243.899V240.613Z",
    fill: "url(#paint111_linear_3875_2346)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2177 217.323L83.2261 215.599V218.899L86.2177 220.623V217.323Z",
    fill: "url(#paint112_linear_3875_2346)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8851 229.769L91.1899 228.22V231.52L93.8851 233.069V229.769Z",
    fill: "url(#paint113_linear_3875_2346)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7259 231.978L95.0308 230.429V233.729L97.7259 235.292V231.978Z",
    fill: "url(#paint114_linear_3875_2346)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3628 229.298L90.0579 230.86V227.56L87.3628 225.998V229.298Z",
    fill: "url(#paint115_linear_3875_2346)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M127.696 249.274V252.574L134.407 256.453V253.153L127.696 249.274Z",
    fill: "url(#paint116_linear_3875_2346)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M126.55 248.614L98.8579 232.638V235.939L126.55 251.914V248.614Z",
    fill: "url(#paint117_linear_3875_2346)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2177 225.338L83.2261 223.614V226.914L86.2177 228.651V225.338Z",
    fill: "url(#paint118_linear_3875_2346)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8851 237.784L91.1899 236.235V239.535L93.8851 241.084V237.784Z",
    fill: "url(#paint119_linear_3875_2346)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7259 240.006L95.0308 238.444V241.744L97.7259 243.306V240.006Z",
    fill: "url(#paint120_linear_3875_2346)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3628 237.312L90.0579 238.875V235.575L87.3628 234.012V237.312Z",
    fill: "url(#paint121_linear_3875_2346)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M127.696 257.288V260.588L134.407 264.468V261.168L127.696 257.288Z",
    fill: "url(#paint122_linear_3875_2346)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M126.55 256.642L98.8579 240.653V243.953L126.55 259.928V256.642Z",
    fill: "url(#paint123_linear_3875_2346)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2177 233.366L83.2261 231.628V234.928L86.2177 236.652V233.366Z",
    fill: "url(#paint124_linear_3875_2346)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8851 245.798L91.1899 244.249V247.55L93.8851 249.099V245.798Z",
    fill: "url(#paint125_linear_3875_2346)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7259 248.021L95.0308 246.458V249.759L97.7259 251.308V248.021Z",
    fill: "url(#paint126_linear_3875_2346)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3628 245.327L90.0579 246.889V243.589L87.3628 242.027V245.327Z",
    fill: "url(#paint127_linear_3875_2346)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M127.696 265.303V268.603L134.407 272.482V269.182L127.696 265.303Z",
    fill: "url(#paint128_linear_3875_2346)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M126.55 264.656L98.8579 248.667V251.968L126.55 267.956V264.656Z",
    fill: "url(#paint129_linear_3875_2346)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2177 241.367L83.2261 239.643V242.943L86.2177 244.68V241.367Z",
    fill: "url(#paint130_linear_3875_2346)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8851 253.813L91.1899 252.264V255.564L93.8851 257.113V253.813Z",
    fill: "url(#paint131_linear_3875_2346)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7259 256.022L95.0308 254.473V257.773L97.7259 259.336V256.022Z",
    fill: "url(#paint132_linear_3875_2346)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3628 253.342L90.0579 254.904V251.604L87.3628 250.042V253.342Z",
    fill: "url(#paint133_linear_3875_2346)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M127.696 273.317V276.618L134.407 280.497V277.197L127.696 273.317Z",
    fill: "url(#paint134_linear_3875_2346)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M126.55 272.671L98.8579 256.682V259.982L126.55 275.971V272.671Z",
    fill: "url(#paint135_linear_3875_2346)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2177 249.395L83.2261 247.657V250.957L86.2177 252.695V249.395Z",
    fill: "url(#paint136_linear_3875_2346)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8851 261.828L91.1899 260.279V263.579L93.8851 265.128V261.828Z",
    fill: "url(#paint137_linear_3875_2346)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7259 264.05L95.0308 262.488V265.788L97.7259 267.35V264.05Z",
    fill: "url(#paint138_linear_3875_2346)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3628 261.356L90.0579 262.919V259.619L87.3628 258.056V261.356Z",
    fill: "url(#paint139_linear_3875_2346)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M127.696 281.332V284.632L134.407 288.511V285.211L127.696 281.332Z",
    fill: "url(#paint140_linear_3875_2346)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M126.55 280.685L98.8579 264.697V267.997L126.55 283.972V280.685Z",
    fill: "url(#paint141_linear_3875_2346)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2177 257.41L83.2261 255.672V258.972L86.2177 260.71V257.41Z",
    fill: "url(#paint142_linear_3875_2346)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M79.062 265.276V75.795L131.496 106.318V295.826L79.062 265.276Z",
    fill: "url(#paint143_linear_3875_2346)"
  }), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M73.375 65.9081V268.536L137.236 305.712V103.045L73.375 65.9081ZM131.496 295.826L79.0618 265.276V75.795L131.496 106.304V295.826Z",
    fill: "url(#paint144_linear_3875_2346)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M73.375 65.9216V268.536L137.182 305.713V103.045L73.375 65.9216Z",
    fill: "url(#paint145_linear_3875_2346)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M73.375 65.9216V134.793L137.182 171.97V103.045L73.375 65.9216Z",
    fill: "url(#paint146_linear_3875_2346)"
  }), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M226.648 337.973V349.153L341.34 283.285V272.092L226.648 337.973Z",
    fill: "url(#paint147_linear_3875_2346)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M226.675 337.973V349.153L162.881 311.989V300.836L226.675 337.973Z",
    fill: "url(#paint148_linear_3875_2346)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M226.648 350.567V361.747L341.34 295.88V284.686L226.648 350.567Z",
    fill: "url(#paint149_linear_3875_2346)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M226.675 350.567V361.747L162.881 324.584V313.431L226.675 350.567Z",
    fill: "url(#paint150_linear_3875_2346)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M162.881 300.836L226.675 337.973L341.34 272.092L277.478 234.915L162.881 300.836Z",
    fill: "url(#paint151_linear_3875_2346)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M162.881 96.175V298.829L277.586 232.962V30.2938L162.881 96.175Z",
    fill: "url(#paint152_linear_3875_2346)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M226.688 143.98V325.055L329.171 266.192V85.1162L226.688 143.98Z",
    fill: "url(#paint153_linear_3875_2346)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M226.729 143.98V325.055L169.727 291.839V110.79L226.729 143.98Z",
    fill: "url(#paint154_linear_3875_2346)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M169.727 110.79L226.729 143.98L329.171 85.1162L272.115 51.8995L169.727 110.79Z",
    fill: "url(#paint155_linear_3875_2346)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M226.648 133.338V336.006L341.34 270.125V67.4706L226.648 133.338Z",
    fill: "url(#paint156_linear_3875_2346)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M162.881 96.2154L226.675 133.338L341.34 67.4706L277.478 30.2938L162.881 96.2154Z",
    fill: "url(#paint157_linear_3875_2346)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M183.391 123.815L180.696 122.253V125.553L183.391 127.115V123.815Z",
    fill: "url(#paint158_linear_3875_2346)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M187.231 126.024L184.536 124.475V127.775L187.231 129.324V126.024Z",
    fill: "url(#paint159_linear_3875_2346)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M176.869 123.344L179.564 124.893V121.606L176.869 120.044V123.344Z",
    fill: "url(#paint160_linear_3875_2346)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M217.202 143.32V146.62L223.913 150.499V147.199L217.202 143.32Z",
    fill: "url(#paint161_linear_3875_2346)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M216.056 142.66L188.363 126.684V129.984L216.056 145.96V142.66Z",
    fill: "url(#paint162_linear_3875_2346)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M175.723 119.384L172.731 117.659V120.96L175.723 122.684V119.384Z",
    fill: "url(#paint163_linear_3875_2346)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M183.391 131.83L180.696 130.267V133.567L183.391 135.13V131.83Z",
    fill: "url(#paint164_linear_3875_2346)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M187.231 134.039L184.536 132.49V135.79L187.231 137.339V134.039Z",
    fill: "url(#paint165_linear_3875_2346)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M176.869 131.358L179.564 132.907V129.621L176.869 128.058V131.358Z",
    fill: "url(#paint166_linear_3875_2346)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M217.202 151.334V154.634L223.913 158.514V155.214L217.202 151.334Z",
    fill: "url(#paint167_linear_3875_2346)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M216.056 150.674L188.363 134.699V137.999L216.056 153.974V150.674Z",
    fill: "url(#paint168_linear_3875_2346)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M175.723 127.398L172.731 125.674V128.974L175.723 130.698V127.398Z",
    fill: "url(#paint169_linear_3875_2346)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M183.391 139.844L180.696 138.282V141.582L183.391 143.144V139.844Z",
    fill: "url(#paint170_linear_3875_2346)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M187.231 142.053L184.536 140.504V143.804L187.231 145.354V142.053Z",
    fill: "url(#paint171_linear_3875_2346)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M176.869 139.373L179.564 140.935V137.635L176.869 136.073V139.373Z",
    fill: "url(#paint172_linear_3875_2346)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M217.202 159.349V162.649L223.913 166.528V163.228L217.202 159.349Z",
    fill: "url(#paint173_linear_3875_2346)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M216.056 158.689L188.363 142.713V146.014L216.056 161.989V158.689Z",
    fill: "url(#paint174_linear_3875_2346)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M175.723 135.413L172.731 133.689V136.989L175.723 138.713V135.413Z",
    fill: "url(#paint175_linear_3875_2346)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M183.391 147.859L180.696 146.296V149.597L183.391 151.159V147.859Z",
    fill: "url(#paint176_linear_3875_2346)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M187.231 150.068L184.536 148.519V151.819L187.231 153.368V150.068Z",
    fill: "url(#paint177_linear_3875_2346)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M176.869 147.387L179.564 148.95V145.65L176.869 144.087V147.387Z",
    fill: "url(#paint178_linear_3875_2346)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M217.202 167.363V170.663L223.913 174.543V171.243L217.202 167.363Z",
    fill: "url(#paint179_linear_3875_2346)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M216.056 166.703L188.363 150.728V154.028L216.056 170.003V166.703Z",
    fill: "url(#paint180_linear_3875_2346)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M175.723 143.427L172.731 141.703V145.003L175.723 146.727V143.427Z",
    fill: "url(#paint181_linear_3875_2346)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M183.391 155.873L180.696 154.311V157.611L183.391 159.174V155.873Z",
    fill: "url(#paint182_linear_3875_2346)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M187.231 158.083L184.536 156.534V159.834L187.231 161.383V158.083Z",
    fill: "url(#paint183_linear_3875_2346)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M176.869 155.402L179.564 156.965V153.664L176.869 152.102V155.402Z",
    fill: "url(#paint184_linear_3875_2346)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M217.202 175.378V178.678L223.913 182.557V179.257L217.202 175.378Z",
    fill: "url(#paint185_linear_3875_2346)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M216.056 174.718L188.363 158.743V162.043L216.056 178.018V174.718Z",
    fill: "url(#paint186_linear_3875_2346)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M175.723 151.442L172.731 149.718V153.018L175.723 154.742V151.442Z",
    fill: "url(#paint187_linear_3875_2346)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M183.391 163.888L180.696 162.339V165.626L183.391 167.188V163.888Z",
    fill: "url(#paint188_linear_3875_2346)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M187.231 166.097L184.536 164.548V167.848L187.231 169.397V166.097Z",
    fill: "url(#paint189_linear_3875_2346)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M176.869 163.417L179.564 164.979V161.679L176.869 160.117V163.417Z",
    fill: "url(#paint190_linear_3875_2346)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M217.202 183.392V186.693L223.913 190.572V187.272L217.202 183.392Z",
    fill: "url(#paint191_linear_3875_2346)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M216.056 182.732L188.363 166.757V170.057L216.056 186.033V182.732Z",
    fill: "url(#paint192_linear_3875_2346)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M175.723 159.457L172.731 157.732V161.032L175.723 162.757V159.457Z",
    fill: "url(#paint193_linear_3875_2346)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M183.391 171.903L180.696 170.354V173.64L183.391 175.203V171.903Z",
    fill: "url(#paint194_linear_3875_2346)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M187.231 174.112L184.536 172.563V175.863L187.231 177.412V174.112Z",
    fill: "url(#paint195_linear_3875_2346)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M176.869 171.431L179.564 172.994V169.694L176.869 168.131V171.431Z",
    fill: "url(#paint196_linear_3875_2346)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M217.202 191.407V194.707L223.913 198.587V195.286L217.202 191.407Z",
    fill: "url(#paint197_linear_3875_2346)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M216.056 190.747L188.363 174.772V178.072L216.056 194.047V190.747Z",
    fill: "url(#paint198_linear_3875_2346)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M175.723 167.471L172.731 165.747V169.047L175.723 170.771V167.471Z",
    fill: "url(#paint199_linear_3875_2346)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M183.391 179.917L180.696 178.355V181.655L183.391 183.217V179.917Z",
    fill: "url(#paint200_linear_3875_2346)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M187.231 182.126L184.536 180.577V183.877L187.231 185.426V182.126Z",
    fill: "url(#paint201_linear_3875_2346)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M176.869 179.446L179.564 181.008V177.708L176.869 176.146V179.446Z",
    fill: "url(#paint202_linear_3875_2346)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M217.202 199.422V202.722L223.913 206.601V203.301L217.202 199.422Z",
    fill: "url(#paint203_linear_3875_2346)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M216.056 198.762L188.363 182.786V186.086L216.056 202.062V198.762Z",
    fill: "url(#paint204_linear_3875_2346)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M175.723 175.486L172.731 173.761V177.062L175.723 178.786V175.486Z",
    fill: "url(#paint205_linear_3875_2346)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M183.391 187.932L180.696 186.383V189.669L183.391 191.232V187.932Z",
    fill: "url(#paint206_linear_3875_2346)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M187.231 190.141L184.536 188.592V191.892L187.231 193.441V190.141Z",
    fill: "url(#paint207_linear_3875_2346)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M176.869 187.46L179.564 189.023V185.723L176.869 184.16V187.46Z",
    fill: "url(#paint208_linear_3875_2346)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M217.202 207.436V210.736L223.913 214.616V211.316L217.202 207.436Z",
    fill: "url(#paint209_linear_3875_2346)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M216.056 206.776L188.363 190.801V194.101L216.056 210.076V206.776Z",
    fill: "url(#paint210_linear_3875_2346)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M175.723 183.5L172.731 181.776V185.076L175.723 186.8V183.5Z",
    fill: "url(#paint211_linear_3875_2346)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M183.391 195.946L180.696 194.384V197.684L183.391 199.247V195.946Z",
    fill: "url(#paint212_linear_3875_2346)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M187.231 198.155L184.536 196.606V199.907L187.231 201.456V198.155Z",
    fill: "url(#paint213_linear_3875_2346)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M176.869 195.475L179.564 197.037V193.737L176.869 192.175V195.475Z",
    fill: "url(#paint214_linear_3875_2346)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M217.202 215.451V218.751L223.913 222.63V219.33L217.202 215.451Z",
    fill: "url(#paint215_linear_3875_2346)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M216.056 214.791L188.363 198.816V202.116L216.056 218.091V214.791Z",
    fill: "url(#paint216_linear_3875_2346)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M175.723 191.528L172.731 189.791V193.091L175.723 194.815V191.528Z",
    fill: "url(#paint217_linear_3875_2346)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M183.391 203.961L180.696 202.412V205.712L183.391 207.261V203.961Z",
    fill: "url(#paint218_linear_3875_2346)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M187.231 206.17L184.536 204.621V207.921L187.231 209.47V206.17Z",
    fill: "url(#paint219_linear_3875_2346)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M176.869 203.49L179.564 205.052V201.752L176.869 200.189V203.49Z",
    fill: "url(#paint220_linear_3875_2346)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M217.202 223.465V226.765L223.913 230.645V227.345L217.202 223.465Z",
    fill: "url(#paint221_linear_3875_2346)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M216.056 222.805L188.363 206.83V210.13L216.056 226.105V222.805Z",
    fill: "url(#paint222_linear_3875_2346)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M175.723 199.529L172.731 197.805V201.105L175.723 202.83V199.529Z",
    fill: "url(#paint223_linear_3875_2346)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M183.391 211.976L180.696 210.427V213.727L183.391 215.276V211.976Z",
    fill: "url(#paint224_linear_3875_2346)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M187.231 214.185L184.536 212.636V215.936L187.231 217.498V214.185Z",
    fill: "url(#paint225_linear_3875_2346)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M176.869 211.504L179.564 213.067V209.766L176.869 208.204V211.504Z",
    fill: "url(#paint226_linear_3875_2346)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M217.202 231.48V234.78L223.913 238.659V235.359L217.202 231.48Z",
    fill: "url(#paint227_linear_3875_2346)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M216.056 230.833L188.363 214.845V218.145L216.056 234.12V230.833Z",
    fill: "url(#paint228_linear_3875_2346)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M175.723 207.557L172.731 205.82V209.12L175.723 210.844V207.557Z",
    fill: "url(#paint229_linear_3875_2346)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M183.391 219.99L180.696 218.441V221.741L183.391 223.29V219.99Z",
    fill: "url(#paint230_linear_3875_2346)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M187.231 222.213L184.536 220.65V223.95L187.231 225.499V222.213Z",
    fill: "url(#paint231_linear_3875_2346)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M176.869 219.519L179.564 221.081V217.781L176.869 216.219V219.519Z",
    fill: "url(#paint232_linear_3875_2346)"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M217.202 239.495V242.795L223.913 246.674V243.374L217.202 239.495Z",
    fill: "url(#paint233_linear_3875_2346)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M216.056 238.835L188.363 222.859V226.159L216.056 242.135V238.835Z",
    fill: "url(#paint234_linear_3875_2346)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M175.723 215.559L172.731 213.834V217.135L175.723 218.859V215.559Z",
    fill: "url(#paint235_linear_3875_2346)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M183.391 228.005L180.696 226.456V229.756L183.391 231.305V228.005Z",
    fill: "url(#paint236_linear_3875_2346)"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M187.231 230.214L184.536 228.665V231.965L187.231 233.527V230.214Z",
    fill: "url(#paint237_linear_3875_2346)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M176.869 227.533L179.564 229.096V225.796L176.869 224.233V227.533Z",
    fill: "url(#paint238_linear_3875_2346)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M217.202 247.509V250.809L223.913 254.689V251.388L217.202 247.509Z",
    fill: "url(#paint239_linear_3875_2346)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M216.056 246.863L188.363 230.874V234.174L216.056 250.163V246.863Z",
    fill: "url(#paint240_linear_3875_2346)"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M175.723 223.587L172.731 221.849V225.149L175.723 226.887V223.587Z",
    fill: "url(#paint241_linear_3875_2346)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M183.391 236.019L180.696 234.47V237.77L183.391 239.319V236.019Z",
    fill: "url(#paint242_linear_3875_2346)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M187.231 238.242L184.536 236.679V239.979L187.231 241.528V238.242Z",
    fill: "url(#paint243_linear_3875_2346)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M176.869 235.548L179.564 237.11V233.81L176.869 232.248V235.548Z",
    fill: "url(#paint244_linear_3875_2346)"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M217.202 255.524V258.824L223.913 262.703V259.403L217.202 255.524Z",
    fill: "url(#paint245_linear_3875_2346)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M216.056 254.877L188.363 238.888V242.189L216.056 258.164V254.877Z",
    fill: "url(#paint246_linear_3875_2346)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M175.723 231.601L172.731 229.864V233.164L175.723 234.888V231.601Z",
    fill: "url(#paint247_linear_3875_2346)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M183.391 244.034L180.696 242.485V245.785L183.391 247.334V244.034Z",
    fill: "url(#paint248_linear_3875_2346)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M187.231 246.243L184.536 244.694V247.994L187.231 249.557V246.243Z",
    fill: "url(#paint249_linear_3875_2346)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M176.869 243.562L179.564 245.125V241.825L176.869 240.262V243.562Z",
    fill: "url(#paint250_linear_3875_2346)"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M217.202 263.538V266.838L223.913 270.718V267.418L217.202 263.538Z",
    fill: "url(#paint251_linear_3875_2346)"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M216.056 262.892L188.363 246.903V250.203L216.056 266.192V262.892Z",
    fill: "url(#paint252_linear_3875_2346)"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M175.723 239.616L172.731 237.878V241.178L175.723 242.916V239.616Z",
    fill: "url(#paint253_linear_3875_2346)"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M183.391 252.048L180.696 250.499V253.8L183.391 255.349V252.048Z",
    fill: "url(#paint254_linear_3875_2346)"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M187.231 254.271L184.536 252.708V256.009L187.231 257.571V254.271Z",
    fill: "url(#paint255_linear_3875_2346)"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M176.869 251.577L179.564 253.139V249.839L176.869 248.277V251.577Z",
    fill: "url(#paint256_linear_3875_2346)"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M217.202 271.553V274.853L223.913 278.732V275.432L217.202 271.553Z",
    fill: "url(#paint257_linear_3875_2346)"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M216.056 270.906L188.363 254.918V258.218L216.056 274.193V270.906Z",
    fill: "url(#paint258_linear_3875_2346)"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M175.723 247.63L172.731 245.893V249.193L175.723 250.917V247.63Z",
    fill: "url(#paint259_linear_3875_2346)"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M183.391 260.063L180.696 258.514V261.814L183.391 263.363V260.063Z",
    fill: "url(#paint260_linear_3875_2346)"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M187.231 262.286L184.536 260.723V264.023L187.231 265.586V262.286Z",
    fill: "url(#paint261_linear_3875_2346)"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M176.869 259.592L179.564 261.154V257.854L176.869 256.292V259.592Z",
    fill: "url(#paint262_linear_3875_2346)"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M217.202 279.568V282.868L223.913 286.747V283.447L217.202 279.568Z",
    fill: "url(#paint263_linear_3875_2346)"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M216.056 278.921L188.363 262.932V266.232L216.056 282.221V278.921Z",
    fill: "url(#paint264_linear_3875_2346)"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M175.723 255.645L172.731 253.907V257.207L175.723 258.945V255.645Z",
    fill: "url(#paint265_linear_3875_2346)"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M183.391 268.078L180.696 266.529V269.829L183.391 271.378V268.078Z",
    fill: "url(#paint266_linear_3875_2346)"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M187.231 270.3L184.536 268.738V272.038L187.231 273.6V270.3Z",
    fill: "url(#paint267_linear_3875_2346)"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M176.869 267.606L179.564 269.169V265.869L176.869 264.306V267.606Z",
    fill: "url(#paint268_linear_3875_2346)"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M217.202 287.582V290.882L223.913 294.761V291.461L217.202 287.582Z",
    fill: "url(#paint269_linear_3875_2346)"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M216.056 286.936L188.363 270.947V274.247L216.056 290.236V286.936Z",
    fill: "url(#paint270_linear_3875_2346)"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M175.723 263.66L172.731 261.922V265.222L175.723 266.96V263.66Z",
    fill: "url(#paint271_linear_3875_2346)"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M183.391 276.092L180.696 274.543V277.843L183.391 279.392V276.092Z",
    fill: "url(#paint272_linear_3875_2346)"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M187.231 278.315L184.536 276.752V280.052L187.231 281.615V278.315Z",
    fill: "url(#paint273_linear_3875_2346)"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M176.869 275.621L179.564 277.183V273.883L176.869 272.334V275.621Z",
    fill: "url(#paint274_linear_3875_2346)"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M217.202 295.597V298.897L223.913 302.776V299.476L217.202 295.597Z",
    fill: "url(#paint275_linear_3875_2346)"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M216.056 294.95L188.363 278.961V282.261L216.056 298.25V294.95Z",
    fill: "url(#paint276_linear_3875_2346)"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M175.723 271.674L172.731 269.937V273.237L175.723 274.974V271.674Z",
    fill: "url(#paint277_linear_3875_2346)"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M183.391 284.107L180.696 282.558V285.858L183.391 287.407V284.107Z",
    fill: "url(#paint278_linear_3875_2346)"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M187.231 286.329L184.536 284.767V288.067L187.231 289.629V286.329Z",
    fill: "url(#paint279_linear_3875_2346)"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M176.869 283.635L179.564 285.198V281.898L176.869 280.349V283.635Z",
    fill: "url(#paint280_linear_3875_2346)"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M217.202 303.611V306.911L223.913 310.791V307.491L217.202 303.611Z",
    fill: "url(#paint281_linear_3875_2346)"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M216.056 302.965L188.363 286.989V290.276L216.056 306.265V302.965Z",
    fill: "url(#paint282_linear_3875_2346)"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M175.723 279.689L172.731 277.951V281.251L175.723 282.989V279.689Z",
    fill: "url(#paint283_linear_3875_2346)"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M183.391 292.121L180.696 290.572V293.872L183.391 295.421V292.121Z",
    fill: "url(#paint284_linear_3875_2346)"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M187.231 294.344L184.536 292.781V296.081L187.231 297.644V294.344Z",
    fill: "url(#paint285_linear_3875_2346)"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M176.869 291.65L179.564 293.212V289.912L176.869 288.35V291.65Z",
    fill: "url(#paint286_linear_3875_2346)"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M217.202 311.626V314.939L223.913 318.805V315.505L217.202 311.626Z",
    fill: "url(#paint287_linear_3875_2346)"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M216.056 310.979L188.363 294.99V298.291L216.056 314.279V310.979Z",
    fill: "url(#paint288_linear_3875_2346)"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M175.723 287.703L172.731 285.966V289.266L175.723 291.003V287.703Z",
    fill: "url(#paint289_linear_3875_2346)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M168.567 295.57V106.089L221.001 136.612V326.119L168.567 295.57Z",
    fill: "url(#paint290_linear_3875_2346)"
  }), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M162.84 96.2019V298.829L226.634 336.006V133.338L162.84 96.2019ZM220.948 326.119L168.527 295.57V106.089L220.948 136.612V326.119Z",
    fill: "url(#paint291_linear_3875_2346)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M162.881 96.2154V298.829L226.675 336.006V133.338L162.881 96.2154Z",
    fill: "url(#paint292_linear_3875_2346)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M162.881 96.2154V165.087L226.675 202.264V133.338L162.881 96.2154Z",
    fill: "url(#paint293_linear_3875_2346)"
  }), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M224.735 356.548V355.389H138.652V357.518C138.126 361.397 140.188 365.182 144.958 367.93L164.714 379.339C174.147 384.794 190.708 384.107 201.624 377.803L215.746 369.654C222.242 365.909 225.301 361.033 224.735 356.548Z",
    fill: "url(#paint294_linear_3875_2346)"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M164.727 375.945L144.972 364.536C135.539 359.08 136.697 349.544 147.667 343.24L161.789 335.09C172.705 328.786 189.239 328.099 198.699 333.555L218.455 344.964C227.888 350.352 226.729 359.956 215.759 366.26L201.623 374.342C190.722 380.726 174.187 381.454 164.727 375.945Z",
    fill: "url(#paint295_linear_3875_2346)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M215.773 365.438L201.637 373.587C190.722 379.891 174.187 380.578 164.727 375.109L144.972 363.714C140.929 361.397 138.894 358.326 138.638 355.134C138.369 358.824 140.43 362.394 144.972 365.007L164.727 376.416C174.16 381.871 190.722 381.198 201.637 374.894L215.773 366.731C222.066 363.108 225.112 358.393 224.761 354.002C224.465 358.003 221.446 362.151 215.773 365.438Z",
    fill: "url(#paint296_radial_3875_2346)"
  }), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M224.734 361.518V360.36C224.222 364.185 221.204 368.105 215.786 371.23L201.65 379.312C190.735 385.616 174.2 386.303 164.74 380.848L144.985 369.439C141.037 367.162 138.961 364.172 138.665 361.006V362.421C138.139 366.3 140.201 370.085 144.972 372.833L164.727 384.242C174.16 389.697 190.722 389.024 201.637 382.706L215.759 374.557C222.241 370.893 225.3 366.004 224.734 361.518Z",
    fill: "url(#paint297_linear_3875_2346)"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M190.344 289.441H173.446L155.065 351.618C155.065 351.618 155.065 351.753 155.065 351.833C155.065 360.454 167.072 367.445 181.895 367.445C196.718 367.445 208.725 360.454 208.725 351.833C208.725 351.753 208.725 351.685 208.725 351.618L190.344 289.441Z",
    fill: "url(#paint298_linear_3875_2346)"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M190.344 289.468C190.344 292.162 186.558 294.384 181.895 294.384C177.233 294.384 173.446 292.189 173.446 289.468C173.446 286.747 177.233 284.551 181.895 284.551C186.558 284.551 190.344 286.76 190.344 289.468Z",
    fill: "url(#paint299_linear_3875_2346)"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M208.725 351.618L205.073 339.279C205.073 339.414 205.073 339.562 205.073 339.71C205.073 347.173 194.684 353.18 181.868 353.18C169.053 353.18 158.663 347.132 158.663 339.71C158.663 339.562 158.663 339.414 158.663 339.279L155.011 351.618C155.011 351.618 155.011 351.753 155.011 351.833C155.011 360.454 167.018 367.445 181.841 367.445C196.665 367.445 208.672 360.454 208.672 351.833C208.672 351.753 208.672 351.685 208.672 351.618H208.725Z",
    fill: "url(#paint300_linear_3875_2346)"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M197.702 314.333C197.708 314.418 197.708 314.504 197.702 314.589C197.702 319.681 190.614 323.803 181.882 323.803C173.149 323.803 166.061 319.681 166.061 314.589C166.061 314.495 166.061 314.401 166.061 314.306L162.342 326.887C162.347 326.977 162.347 327.067 162.342 327.157C162.342 333.42 171.074 338.512 181.855 338.512C192.635 338.512 201.367 333.42 201.367 327.157C201.362 327.085 201.362 327.013 201.367 326.941L197.702 314.333Z",
    fill: "url(#paint301_linear_3875_2346)"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M190.344 289.441C190.344 292.135 186.558 294.357 181.895 294.357C177.232 294.357 173.446 292.162 173.446 289.441L169.753 301.981C169.753 305.874 175.144 309.04 181.882 309.04C188.619 309.04 194.01 305.874 194.01 301.981L190.344 289.441Z",
    fill: "url(#paint302_linear_3875_2346)"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M188.835 289.198C188.835 291.152 185.722 292.728 181.895 292.728C178.068 292.728 174.969 291.205 174.969 289.198C174.969 287.191 178.068 285.656 181.909 285.656C185.749 285.656 188.835 287.232 188.835 289.198Z",
    fill: "url(#paint303_linear_3875_2346)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M188.835 289.198C188.835 291.152 185.722 292.728 181.895 292.728C178.068 292.728 174.969 291.205 174.969 289.198C174.969 287.191 178.068 285.656 181.909 285.656C185.749 285.656 188.835 287.232 188.835 289.198Z",
    fill: "url(#paint304_linear_3875_2346)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M188.943 287.232L183.485 288.282L189.307 350.473V350.688C190.937 359.161 196.152 365.276 200.936 364.36C205.72 363.444 208.294 355.82 206.664 347.348C206.668 347.276 206.668 347.204 206.664 347.132L188.943 287.232Z",
    fill: "url(#paint305_radial_3875_2346)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M176.006 287.232L181.478 288.282L175.656 350.473C175.656 350.554 175.656 350.621 175.656 350.688C174.012 359.161 168.81 365.276 164.013 364.36C159.216 363.444 156.669 355.82 158.299 347.348V347.132L176.006 287.232Z",
    fill: "url(#paint306_radial_3875_2346)"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.6614 297.253L66.2734 306.157L74.2915 301.537L75.6795 292.633L67.6614 297.253Z",
    fill: "url(#paint307_linear_3875_2346)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6886 297.254L66.3006 306.157L58.3364 301.537L59.7244 292.66L67.6886 297.254Z",
    fill: "url(#paint308_linear_3875_2346)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.96387 332.571L12.9634 340.411L20.9814 335.804L15.9819 327.951L7.96387 332.571Z",
    fill: "url(#paint309_linear_3875_2346)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.97752 332.572L12.9905 340.411L5.02634 335.804L0.0268555 327.978L7.97752 332.572Z",
    fill: "url(#paint310_linear_3875_2346)"
  }))), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0083 187.932L67.5671 296.001L75.5852 291.394L58.0263 183.312L50.0083 187.932Z",
    fill: "url(#paint311_linear_3875_2346)"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M50.022 187.932L67.5808 296.001L59.6301 291.394L42.0713 183.339L50.022 187.932Z",
    fill: "url(#paint312_linear_3875_2346)"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0082 187.932L7.93701 331.467L15.9551 326.847L58.0262 183.312L50.0082 187.932Z",
    fill: "url(#paint313_linear_3875_2346)"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0218 187.932L7.95067 331.467L0 326.847L42.0712 183.339L50.0218 187.932Z",
    fill: "url(#paint314_linear_3875_2346)"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0713 183.339L50.022 187.932L58.0265 183.312L50.022 178.692L42.0713 183.339Z",
    fill: "url(#paint315_linear_3875_2346)"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7976 337.703L80.5444 340.95L16.8447 304.702L18.098 301.469L81.7976 337.703Z",
    fill: "url(#paint316_linear_3875_2346)"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0977 301.47L81.7973 337.704L86.3521 335.131L22.6255 298.883L18.0977 301.47Z",
    fill: "url(#paint317_linear_3875_2346)"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M122.09 229.136L139.649 337.205L147.667 332.598L130.121 224.516L122.09 229.136Z",
    fill: "url(#paint318_linear_3875_2346)"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M122.117 229.136L139.676 337.205L131.711 332.598L114.166 224.543L122.117 229.136Z",
    fill: "url(#paint319_linear_3875_2346)"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M114.166 224.543L122.117 229.136L130.121 224.516L122.117 219.896L114.166 224.543Z",
    fill: "url(#paint320_linear_3875_2346)"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M122.09 229.136L80.0186 372.671L88.0501 368.051L130.121 224.516L122.09 229.136Z",
    fill: "url(#paint321_linear_3875_2346)"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M122.117 229.136L80.0459 372.671L72.0952 368.051L114.166 224.543L122.117 229.136Z",
    fill: "url(#paint322_linear_3875_2346)"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M114.166 224.543L122.117 229.136L130.121 224.516L122.117 219.896L114.166 224.543Z",
    fill: "url(#paint323_linear_3875_2346)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.581 338.337L138.207 347.24L146.225 342.62L147.613 333.716L139.581 338.337Z",
    fill: "url(#paint324_linear_3875_2346)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.608 338.337L138.22 347.24L130.27 342.62L131.658 333.744L139.608 338.337Z",
    fill: "url(#paint325_linear_3875_2346)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.8843 373.655L84.8972 381.494L92.9153 376.887L87.9023 369.034L79.8843 373.655Z",
    fill: "url(#paint326_linear_3875_2346)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9111 373.655L84.9106 381.494L76.9599 376.887L71.9604 369.061L79.9111 373.655Z",
    fill: "url(#paint327_linear_3875_2346)"
  }))), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M108.938 312.245L14.1359 257.692C10.0932 255.403 8.09879 249.503 9.58112 244.532L14.1359 229.352C14.8906 226.819 11.8316 226.658 13.6643 225.809L18.7042 223.964C19.5849 223.64 20.5276 223.52 21.4613 223.614C22.395 223.707 23.2954 224.011 24.0945 224.503L118.896 279.083C122.939 281.372 124.947 287.272 123.451 292.243L118.896 307.369C118.609 308.558 118.05 309.664 117.261 310.599C116.473 311.534 115.478 312.273 114.355 312.757L109.396 314.616C107.765 315.182 110.703 313.256 108.938 312.245Z",
    fill: "url(#paint328_linear_3875_2346)"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M104.167 314.104L9.36545 259.551C5.32274 257.261 3.31489 251.361 4.8107 246.391L9.36545 231.211C10.8478 226.227 15.3082 224.058 19.3105 226.361L114.112 280.914C118.155 283.204 120.149 289.104 118.667 294.074L114.112 309.255C112.63 314.104 108.169 316.34 104.167 314.104Z",
    fill: "url(#paint329_linear_3875_2346)"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M120.378 274.126L25.5632 219.573C21.5205 217.283 19.5261 211.383 21.0219 206.412L25.5632 191.232C26.3313 188.7 23.2723 188.538 25.105 187.703C25.2533 187.622 29.9832 185.898 30.1314 185.844C31.0121 185.52 31.9549 185.4 32.8886 185.494C33.8223 185.587 34.7227 185.891 35.5217 186.383L130.337 240.936C134.38 243.226 136.374 249.125 134.878 254.096L130.337 269.276C130.045 270.463 129.484 271.566 128.696 272.501C127.909 273.435 126.916 274.176 125.796 274.664L120.836 276.523C119.192 277.062 122.117 275.136 120.378 274.126Z",
    fill: "url(#paint330_linear_3875_2346)"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M115.595 275.917L20.7795 221.364C16.7368 219.074 14.7424 213.174 16.2382 208.204L20.7795 193.023C22.2753 188.04 26.7223 185.871 30.7246 188.174L125.54 242.714C129.582 245.004 131.577 250.903 130.081 255.874L125.54 271.054C124.044 276.052 119.597 278.22 115.595 275.917Z",
    fill: "url(#paint331_linear_3875_2346)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M114.853 280.524L19.9977 225.971C19.2264 225.505 18.3631 225.211 17.4673 225.111C16.5716 225.011 15.6647 225.107 14.8096 225.392C16.1498 225.275 17.4928 225.582 18.6502 226.267L113.452 280.82C117.494 283.123 119.489 289.01 118.007 293.994L113.452 309.174C113.174 310.248 112.681 311.254 112.002 312.132C111.323 313.009 110.473 313.74 109.503 314.279C109.964 314.217 110.416 314.104 110.851 313.943C111.81 313.407 112.65 312.682 113.32 311.811C113.99 310.94 114.475 309.942 114.745 308.878L119.3 293.697C120.904 288.713 118.856 282.827 114.853 280.524Z",
    fill: "url(#paint332_radial_3875_2346)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M126.281 242.404L31.4791 187.851C30.7078 187.385 29.8445 187.092 28.9487 186.992C28.053 186.892 27.1462 186.987 26.291 187.272C27.627 187.156 28.9657 187.462 30.1181 188.147L124.933 242.714C128.976 245.017 130.97 250.904 129.474 255.887L124.933 271.001C124.653 272.074 124.159 273.079 123.48 273.956C122.802 274.833 121.953 275.565 120.985 276.106C121.445 276.042 121.897 275.93 122.332 275.769C123.289 275.23 124.127 274.503 124.796 273.633C125.465 272.763 125.952 271.767 126.227 270.704L130.768 255.524C132.318 250.607 130.283 244.707 126.281 242.404Z",
    fill: "url(#paint333_radial_3875_2346)"
  }), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M100.812 304.743L17.1548 256.749L36.0477 194.29L119.705 242.269L100.812 304.743Z",
    fill: "black"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M100.502 304.298L17.6265 256.749L36.2903 194.977L119.179 242.525L100.502 304.298Z",
    fill: "black"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M100.205 303.854L18.0845 256.736L36.5327 195.664L118.654 242.781L100.205 303.854Z",
    fill: "black"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M99.909 303.409L18.5562 256.736L36.7753 196.364L118.128 243.024L99.909 303.409Z",
    fill: "black"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M99.6124 302.965L19.0142 256.736L37.0177 197.051L117.602 243.28L99.6124 302.965Z",
    fill: "black"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M99.3159 302.52L19.4858 256.723L37.2603 197.738L117.077 243.536L99.3159 302.52Z",
    fill: "black"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M99.0195 302.076L19.9575 256.722L37.4894 198.425L116.565 243.778L99.0195 302.076Z",
    fill: "black"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M98.7094 301.631L20.4155 256.709L37.7318 199.125L116.039 244.034L98.7094 301.631Z",
    fill: "black"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M98.413 301.187L20.8872 256.709L37.9744 199.812L115.514 244.29L98.413 301.187Z",
    fill: "black"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M98.1168 300.742L21.3457 256.696L38.2173 200.499L114.988 244.532L98.1168 300.742Z",
    fill: "black"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M97.8204 300.298L21.8174 256.696L38.4599 201.186L114.463 244.788L97.8204 300.298Z",
    fill: "black"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M97.5237 299.853L22.2754 256.682L38.7023 201.887L113.937 245.044L97.5237 299.853Z",
    fill: "black"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8173 303.167L17.9092 256.75L35.5624 197.805L116.484 244.223L98.8173 303.167Z",
    fill: "url(#paint334_linear_3875_2346)"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8638 205.268L110.352 246.27L95.5292 295.65L24.0405 254.635L38.8638 205.268ZM38.0553 203.247L22.4639 255.268L96.3647 297.658L111.943 245.637L38.0688 203.247H38.0553Z",
    fill: "url(#paint335_linear_3875_2346)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M35.5626 197.805L35.1987 198.775L115.487 244.64L98.1977 302.614L98.8175 303.167L116.484 244.223L35.5626 197.805Z",
    fill: "url(#paint336_radial_3875_2346)"
  }), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0583 233.285C36.4168 231.741 36.364 230.016 36.91 228.436L39.2817 220.515C39.2961 220.454 39.3242 220.397 39.3638 220.348C39.4035 220.299 39.4538 220.259 39.5109 220.233C39.5673 220.204 39.6296 220.189 39.6927 220.189C39.7559 220.189 39.8183 220.204 39.8747 220.233L41.5591 221.162C41.6898 221.232 41.7904 221.347 41.8421 221.485C41.8894 221.62 41.8894 221.768 41.8421 221.903L39.4704 229.823C39.1696 230.696 39.1696 231.644 39.4704 232.517C39.7916 233.329 40.3943 233.998 41.1683 234.403C41.4775 234.627 41.8354 234.774 42.2126 234.832C42.5897 234.891 42.9755 234.859 43.338 234.74C43.6936 234.541 43.9996 234.265 44.233 233.931C44.4664 233.598 44.6211 233.215 44.6855 232.813L47.0572 224.893C47.0736 224.832 47.1046 224.776 47.1476 224.729C47.1905 224.683 47.2441 224.647 47.3038 224.626C47.3635 224.605 47.4274 224.599 47.4901 224.608C47.5527 224.616 47.6123 224.641 47.6636 224.678L49.3346 225.634C49.4614 225.702 49.5613 225.811 49.6176 225.944C49.6649 226.084 49.6649 226.235 49.6176 226.375L47.2459 234.282C47.122 235.001 46.8222 235.679 46.3732 236.254C45.9242 236.83 45.3398 237.286 44.672 237.582C43.9488 237.744 43.1994 237.752 42.4727 237.606C41.746 237.46 41.0583 237.163 40.4541 236.733C38.9911 235.964 37.8041 234.759 37.0583 233.285Z",
    fill: "url(#paint337_linear_3875_2346)"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0648 241.367C49.0175 241.236 49.0175 241.093 49.0648 240.963L52.865 228.301C52.877 228.241 52.9026 228.184 52.9399 228.135C52.9773 228.086 53.0254 228.046 53.0806 228.018C53.1378 227.993 53.1998 227.979 53.2625 227.979C53.3252 227.979 53.3872 227.993 53.4444 228.018L54.8594 228.84C54.9745 228.906 55.0732 228.997 55.1479 229.107C55.2226 229.217 55.2714 229.342 55.2906 229.473L57.9049 241.098L60.4518 232.611C60.4617 232.55 60.4865 232.492 60.5241 232.443C60.5618 232.394 60.6109 232.354 60.6674 232.329C60.7238 232.3 60.7861 232.285 60.8493 232.285C60.9125 232.285 60.9748 232.3 61.0313 232.329L62.5944 233.218C62.7222 233.291 62.8218 233.405 62.8774 233.541C62.9247 233.681 62.9247 233.832 62.8774 233.972L59.0773 246.647C59.0655 246.708 59.0388 246.765 58.9996 246.813C58.9604 246.862 58.9098 246.899 58.8525 246.923C58.7951 246.947 58.7328 246.957 58.6709 246.951C58.609 246.945 58.5496 246.924 58.4978 246.89L57.0559 246.068C56.9379 246.001 56.8366 245.907 56.7596 245.795C56.6826 245.684 56.6319 245.556 56.6112 245.421L53.9161 233.999L51.4231 242.31C51.4108 242.37 51.3833 242.427 51.3431 242.474C51.3029 242.521 51.2513 242.557 51.1933 242.579C51.1353 242.6 51.0727 242.607 51.0115 242.597C50.9503 242.588 50.8926 242.563 50.8436 242.525L49.2804 241.636C49.1876 241.565 49.1136 241.473 49.0648 241.367Z",
    fill: "url(#paint338_linear_3875_2346)"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3793 248.95C62.3319 248.82 62.3319 248.677 62.3793 248.546L66.1794 235.885C66.1893 235.823 66.2142 235.766 66.2518 235.716C66.2894 235.667 66.3386 235.628 66.395 235.602C66.4514 235.573 66.5138 235.559 66.5769 235.559C66.6401 235.559 66.7024 235.573 66.7589 235.602L71.1924 238.148C74.7859 240.195 76.0841 243.006 75.0869 246.58C74.8847 247.334 74.75 247.927 74.6691 248.115L74.184 249.584C74.0414 250.288 73.7338 250.948 73.2863 251.51C72.8389 252.072 72.2644 252.519 71.6101 252.816C70.8455 252.957 70.0602 252.94 69.3023 252.767C68.5445 252.593 67.8303 252.266 67.2036 251.806L62.6757 249.22C62.5532 249.16 62.4504 249.067 62.3793 248.95ZM67.7696 249.557C68.108 249.812 68.497 249.992 68.9106 250.085C69.3243 250.178 69.7531 250.181 70.1682 250.095C70.7612 249.866 71.2328 249.206 71.5966 248.102C71.8527 247.334 72.0009 246.863 72.0683 246.661C72.1357 246.459 72.2569 245.974 72.4591 245.206C72.7734 244.308 72.7734 243.329 72.4591 242.431C72.0252 241.551 71.3154 240.837 70.4377 240.397L68.2277 239.131L65.5326 248.237L67.7696 249.557Z",
    fill: "url(#paint339_linear_3875_2346)"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6259 256.547C75.5785 256.417 75.5785 256.274 75.6259 256.143L79.4125 243.482C79.4249 243.42 79.4522 243.361 79.4921 243.312C79.532 243.263 79.5833 243.224 79.6416 243.199C79.6988 243.173 79.7608 243.16 79.8235 243.16C79.8862 243.16 79.9482 243.173 80.0055 243.199L88.0235 247.806C88.1513 247.879 88.2509 247.993 88.3065 248.129C88.3537 248.269 88.3537 248.42 88.3065 248.56L87.9157 249.907C87.9036 249.967 87.8762 250.024 87.8361 250.071C87.796 250.118 87.7446 250.154 87.6866 250.176C87.6294 250.202 87.5674 250.215 87.5047 250.215C87.442 250.215 87.38 250.202 87.3228 250.176L81.353 246.755L80.3289 250.149L85.8943 253.342C86.0221 253.415 86.1217 253.529 86.1773 253.665C86.2314 253.804 86.2314 253.957 86.1773 254.096L85.8135 255.322C85.7992 255.381 85.771 255.437 85.7312 255.484C85.6914 255.531 85.6411 255.567 85.5844 255.591C85.5268 255.615 85.4649 255.628 85.4025 255.628C85.34 255.628 85.2782 255.615 85.2205 255.591L79.6551 252.399L78.5905 255.928L84.7085 259.43C84.8382 259.494 84.9392 259.605 84.9915 259.74C85.0462 259.874 85.0462 260.024 84.9915 260.157L84.6007 261.504C84.5886 261.565 84.5612 261.622 84.5211 261.669C84.481 261.716 84.4295 261.752 84.3716 261.774C84.3139 261.798 84.2521 261.81 84.1897 261.81C84.1272 261.81 84.0654 261.798 84.0077 261.774L75.8415 257.086C75.7602 257.024 75.6972 256.941 75.6593 256.847C75.6213 256.752 75.6098 256.648 75.6259 256.547Z",
    fill: "url(#paint340_linear_3875_2346)"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3763 263.309C87.329 263.179 87.329 263.036 87.3763 262.905L91.1765 250.243C91.1888 250.181 91.2162 250.123 91.2561 250.074C91.296 250.024 91.3473 249.986 91.4056 249.961C91.4596 249.932 91.5197 249.917 91.5808 249.917C91.6418 249.917 91.7019 249.932 91.7559 249.961L96.4724 252.655C97.8091 253.361 98.9099 254.442 99.6392 255.766C100.257 256.965 100.373 258.361 99.9626 259.645C99.7678 260.458 99.2901 261.174 98.6151 261.666C98.2916 261.87 97.9307 262.007 97.5535 262.069C97.1763 262.132 96.7904 262.118 96.4185 262.03L97.5775 268.509C97.5921 268.589 97.5921 268.671 97.5775 268.751C97.5633 268.802 97.5377 268.849 97.5027 268.889C97.4676 268.928 97.4241 268.96 97.3753 268.98C97.2758 269.02 97.1649 269.02 97.0654 268.98L95.3944 268.024C95.2221 267.933 95.0812 267.792 94.9901 267.62C94.8997 267.447 94.8404 267.26 94.8149 267.067L93.8582 261.127L91.3651 259.699L90.0176 264.36C90.0014 264.419 89.9726 264.473 89.933 264.52C89.8934 264.567 89.8441 264.604 89.7885 264.629C89.7288 264.654 89.6646 264.667 89.5998 264.667C89.535 264.667 89.4709 264.654 89.4112 264.629L87.7402 263.659C87.6583 263.63 87.5837 263.583 87.521 263.523C87.4583 263.463 87.409 263.39 87.3763 263.309ZM94.505 258.945C94.7615 259.129 95.0519 259.261 95.3595 259.332C95.6671 259.404 95.9857 259.414 96.2973 259.363C96.5554 259.27 96.784 259.11 96.9594 258.899C97.1348 258.688 97.2504 258.434 97.2944 258.164C97.5 257.565 97.4712 256.91 97.2136 256.332C96.8874 255.695 96.3688 255.176 95.7313 254.85L93.2113 253.409L91.985 257.45L94.505 258.945Z",
    fill: "url(#paint341_linear_3875_2346)"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1153 247.118C30.853 246.424 30.8199 245.664 31.021 244.95C31.021 244.788 31.1423 244.519 31.2501 244.155L31.5061 243.347C31.5619 243.018 31.704 242.71 31.9178 242.454C32.1316 242.198 32.4096 242.003 32.7233 241.889C33.037 241.776 33.3752 241.747 33.7035 241.807C34.0318 241.867 34.3384 242.012 34.592 242.229C35.0503 242.49 35.4532 242.837 35.7779 243.253C36.0551 243.604 36.2487 244.014 36.3439 244.451C36.4381 244.832 36.4381 245.229 36.3439 245.61C36.3377 245.632 36.3258 245.653 36.3092 245.669C36.2927 245.686 36.2721 245.698 36.2495 245.704C36.2266 245.716 36.2012 245.722 36.1754 245.722C36.1497 245.722 36.1243 245.716 36.1013 245.704L35.6836 245.462C35.6562 245.451 35.6312 245.434 35.6103 245.414C35.5895 245.393 35.5731 245.368 35.5623 245.34C35.545 245.279 35.545 245.214 35.5623 245.152C35.6282 244.713 35.5527 244.265 35.3467 243.872C35.1135 243.507 34.7881 243.21 34.4034 243.01C33.4197 242.444 32.7324 242.727 32.3416 243.886L32.1125 244.627C32.0047 244.963 31.9373 245.219 31.8834 245.408C31.6808 245.901 31.6723 246.453 31.8598 246.953C32.0472 247.453 32.4167 247.863 32.8941 248.102C33.221 248.317 33.6085 248.421 33.9991 248.398C34.1766 248.36 34.3424 248.28 34.483 248.165C34.6235 248.051 34.7348 247.904 34.8076 247.738C34.8207 247.71 34.8394 247.684 34.8625 247.664C34.8857 247.643 34.9129 247.627 34.9424 247.617C34.9906 247.601 35.0425 247.601 35.0907 247.617L35.5084 247.859C35.561 247.885 35.6035 247.928 35.6297 247.981C35.6493 248.033 35.6493 248.09 35.6297 248.142C35.5173 248.468 35.3111 248.754 35.0367 248.964C34.7448 249.178 34.3872 249.282 34.0261 249.26C33.548 249.221 33.0862 249.068 32.6785 248.816C31.9701 248.456 31.4151 247.854 31.1153 247.118Z",
    fill: "url(#paint342_linear_3875_2346)"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M36.964 250.513C36.6774 249.8 36.6488 249.009 36.8832 248.277C36.8832 248.088 37.0045 247.832 37.1123 247.496L37.3413 246.741C37.4106 246.416 37.5569 246.111 37.7678 245.853C37.9788 245.596 38.2484 245.392 38.5541 245.26C38.8711 245.174 39.2029 245.158 39.5265 245.214C39.8501 245.27 40.1576 245.396 40.4273 245.583C41.0845 245.94 41.6055 246.503 41.9096 247.186C42.2064 247.896 42.2398 248.689 42.0039 249.422L41.8018 250.19C41.8018 250.338 41.667 250.594 41.5458 250.957C41.4761 251.283 41.3331 251.588 41.1276 251.849C40.9221 252.111 40.6595 252.322 40.3599 252.466C40.0378 252.546 39.7024 252.554 39.3766 252.492C39.0509 252.429 38.7427 252.296 38.4733 252.102C37.8063 251.756 37.2749 251.197 36.964 250.513ZM39.9152 251.537C40.1275 251.427 40.3134 251.273 40.46 251.085C40.6066 250.896 40.7104 250.678 40.7642 250.446C40.8855 250.095 40.9528 249.853 40.9932 249.732C41.0337 249.61 41.1011 249.355 41.1954 248.991C41.373 248.471 41.373 247.908 41.1954 247.388C41.0086 246.938 40.6766 246.563 40.2521 246.324C40.074 246.204 39.8712 246.127 39.6589 246.096C39.4466 246.066 39.2302 246.084 39.0258 246.149C38.811 246.256 38.6239 246.412 38.479 246.603C38.3341 246.795 38.2353 247.017 38.1903 247.253C38.1229 247.415 38.0555 247.657 37.9612 247.967C37.8669 248.277 37.7995 248.506 37.7456 248.695C37.567 249.209 37.567 249.769 37.7456 250.284C37.9285 250.744 38.2671 251.125 38.7024 251.362C38.8763 251.484 39.0769 251.564 39.2877 251.595C39.4985 251.625 39.7136 251.605 39.9152 251.537Z",
    fill: "url(#paint343_linear_3875_2346)"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3812 254.177C42.3678 254.147 42.3608 254.115 42.3608 254.082C42.3608 254.05 42.3678 254.018 42.3812 253.988L44.1465 248.075C44.1497 248.048 44.1601 248.022 44.1767 248.001C44.1934 247.98 44.2155 247.963 44.2408 247.954C44.2408 247.954 44.3351 247.954 44.4025 247.954L44.7664 248.169C44.8153 248.194 44.857 248.231 44.8877 248.277V248.412L46.3296 254.716L47.6771 250.136C47.6825 250.108 47.6937 250.082 47.71 250.058C47.7262 250.035 47.7471 250.016 47.7714 250.001C47.8235 249.981 47.8811 249.981 47.9332 250.001L48.3105 250.217C48.3689 250.252 48.4157 250.303 48.4452 250.365C48.4586 250.394 48.4656 250.426 48.4656 250.459C48.4656 250.492 48.4586 250.524 48.4452 250.553L46.6799 256.453C46.6745 256.481 46.6633 256.507 46.6471 256.53C46.6308 256.554 46.6099 256.573 46.5856 256.588C46.5606 256.601 46.5329 256.608 46.5048 256.608C46.4766 256.608 46.4488 256.601 46.4239 256.588L46.0465 256.372C45.9985 256.351 45.9569 256.317 45.9261 256.275C45.8954 256.232 45.8765 256.182 45.8714 256.13L44.4295 249.88L43.0819 254.419C43.0819 254.487 43.0819 254.527 42.9741 254.54C42.9512 254.552 42.9258 254.558 42.9 254.558C42.8742 254.558 42.8488 254.552 42.8259 254.54L42.4351 254.325C42.4069 254.28 42.3885 254.229 42.3812 254.177Z",
    fill: "url(#paint344_linear_3875_2346)"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1191 257.935C48.8465 257.627 48.6442 257.264 48.5262 256.871C48.4333 256.545 48.4333 256.2 48.5262 255.874C48.5324 255.851 48.5443 255.831 48.5609 255.814C48.5774 255.798 48.5979 255.786 48.6205 255.78C48.6416 255.77 48.6646 255.765 48.6879 255.765C48.7112 255.765 48.7341 255.77 48.7553 255.78L49.173 256.022C49.2257 256.051 49.2691 256.094 49.2978 256.146C49.3265 256.199 49.3393 256.259 49.3347 256.318C49.317 256.642 49.4019 256.962 49.5773 257.234C49.8069 257.603 50.1332 257.901 50.5206 258.096C50.8609 258.331 51.2661 258.454 51.6795 258.447C51.8202 258.423 51.9506 258.358 52.0539 258.259C52.1572 258.161 52.2286 258.034 52.259 257.894C52.3257 257.698 52.3257 257.485 52.259 257.288C52.1577 257.051 52.0164 256.832 51.8412 256.642C51.5524 256.307 51.2465 255.988 50.9249 255.685C50.595 255.371 50.2929 255.028 50.022 254.662C49.8232 254.397 49.681 254.094 49.6042 253.773C49.5313 253.463 49.5313 253.14 49.6042 252.83C49.6849 252.531 49.8657 252.27 50.1163 252.089C50.382 251.925 50.6964 251.858 51.0057 251.9C51.4216 251.947 51.822 252.085 52.1781 252.304C52.5882 252.528 52.9464 252.835 53.2292 253.207C53.4761 253.506 53.6554 253.856 53.7547 254.231C53.8341 254.531 53.8341 254.846 53.7547 255.147C53.7494 255.171 53.738 255.194 53.7215 255.213C53.705 255.231 53.684 255.246 53.6604 255.254C53.64 255.266 53.6167 255.272 53.593 255.272C53.5694 255.272 53.5462 255.266 53.5257 255.254L53.0944 255.012C53.052 254.983 53.0154 254.947 52.9867 254.904C52.9661 254.843 52.9661 254.777 52.9867 254.716C53.0175 254.408 52.9414 254.098 52.771 253.84C52.5698 253.516 52.2862 253.251 51.949 253.072C51.6573 252.881 51.3143 252.782 50.9653 252.789C50.8305 252.804 50.7041 252.862 50.6046 252.954C50.5052 253.046 50.4379 253.168 50.4128 253.301C50.359 253.5 50.359 253.709 50.4128 253.907C50.5038 254.137 50.6312 254.351 50.7901 254.54C50.9788 254.769 51.2618 255.066 51.6391 255.443C51.9992 255.775 52.3326 256.136 52.6363 256.52C52.8512 256.78 53.0075 257.084 53.0944 257.41C53.1743 257.723 53.1743 258.052 53.0944 258.366C53.0435 258.611 52.9197 258.834 52.7393 259.007C52.5589 259.18 52.3304 259.295 52.0838 259.336C51.4555 259.396 50.826 259.234 50.305 258.878C49.8576 258.635 49.4562 258.316 49.1191 257.935Z",
    fill: "url(#paint345_linear_3875_2346)"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1561 261.572C55.1365 261.51 55.1365 261.444 55.1561 261.383L56.7597 255.995L55.1291 255.052C55.0998 255.041 55.0736 255.023 55.0525 254.999C55.0315 254.976 55.0162 254.948 55.0079 254.918C54.9883 254.856 54.9883 254.79 55.0079 254.729L55.1157 254.379C55.1188 254.352 55.1293 254.326 55.1459 254.305C55.1625 254.284 55.1847 254.267 55.21 254.258C55.235 254.245 55.2627 254.238 55.2908 254.238C55.319 254.238 55.3467 254.245 55.3717 254.258L59.4144 256.588C59.4658 256.627 59.5073 256.678 59.5357 256.736C59.5491 256.766 59.556 256.798 59.556 256.83C59.556 256.863 59.5491 256.895 59.5357 256.925L59.4279 257.275C59.4248 257.302 59.4143 257.327 59.3977 257.349C59.381 257.37 59.3589 257.386 59.3336 257.396C59.3086 257.409 59.2809 257.416 59.2527 257.416C59.2246 257.416 59.1968 257.409 59.1719 257.396L57.5548 256.467L55.9511 261.855C55.9511 261.922 55.9512 261.962 55.8434 261.976C55.8184 261.989 55.7907 261.996 55.7625 261.996C55.7344 261.996 55.7066 261.989 55.6817 261.976L55.2774 261.747C55.2209 261.701 55.1788 261.641 55.1561 261.572Z",
    fill: "url(#paint346_linear_3875_2346)"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9564 263.673C58.9358 263.616 58.9358 263.554 58.9564 263.498L60.7352 257.585C60.7387 257.556 60.7491 257.529 60.7655 257.505C60.782 257.482 60.8039 257.463 60.8295 257.45C60.8524 257.438 60.8778 257.432 60.9036 257.432C60.9294 257.432 60.9548 257.438 60.9777 257.45L63.053 258.635C63.623 258.945 64.0911 259.412 64.4006 259.982C64.5342 260.247 64.6138 260.536 64.6346 260.832C64.6554 261.128 64.6171 261.425 64.5218 261.706C64.4796 261.899 64.3994 262.082 64.2861 262.244C64.1727 262.406 64.0284 262.543 63.8615 262.649C63.699 262.741 63.5194 262.798 63.3338 262.816C63.1482 262.835 62.9608 262.815 62.7835 262.757L63.3629 265.922C63.3706 265.958 63.3706 265.995 63.3629 266.03C63.358 266.053 63.3482 266.074 63.3342 266.093C63.3203 266.111 63.3025 266.127 63.2821 266.138C63.2382 266.151 63.1912 266.151 63.1473 266.138L62.77 265.922C62.6919 265.881 62.6302 265.815 62.5948 265.734C62.5498 265.655 62.5223 265.568 62.5139 265.478L61.9615 262.447L60.4252 261.572L59.711 263.929C59.7032 263.956 59.6895 263.981 59.6708 264.002C59.6522 264.023 59.6291 264.039 59.6032 264.05C59.5507 264.068 59.494 264.068 59.4415 264.05L59.0372 263.808C59.0148 263.792 58.996 263.772 58.9821 263.749C58.9681 263.726 58.9594 263.7 58.9564 263.673ZM62.0962 261.679C62.9452 262.164 63.4438 262.016 63.7133 261.262C63.824 260.888 63.7898 260.487 63.6174 260.137C63.4451 259.788 63.1473 259.516 62.7835 259.376L61.355 258.554L60.6678 260.858L62.0962 261.679Z",
    fill: "url(#paint347_linear_3875_2346)"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M65.33 266.771C65.0651 266.049 65.0651 265.257 65.33 264.535L66.4216 260.858C66.4216 260.79 66.4215 260.737 66.5293 260.723C66.5528 260.713 66.578 260.708 66.6035 260.708C66.6289 260.708 66.6542 260.713 66.6776 260.723L67.0819 260.966C67.1424 260.991 67.1907 261.04 67.2166 261.1C67.23 261.13 67.2369 261.162 67.2369 261.195C67.2369 261.227 67.23 261.259 67.2166 261.289L66.1116 264.993C65.9359 265.49 65.9359 266.032 66.1116 266.529C66.29 266.988 66.6303 267.367 67.0684 267.593C67.2427 267.72 67.4451 267.804 67.6585 267.836C67.8719 267.869 68.0901 267.85 68.2947 267.781C68.4955 267.666 68.6692 267.509 68.8041 267.321C68.9389 267.132 69.0318 266.917 69.0763 266.69L70.1812 262.986C70.1844 262.959 70.1948 262.934 70.2115 262.912C70.2281 262.891 70.2503 262.874 70.2756 262.865C70.2756 262.865 70.3699 262.865 70.4373 262.865L70.8416 263.094C70.8951 263.125 70.9375 263.172 70.9629 263.228C70.9825 263.29 70.9825 263.356 70.9629 263.417L69.8578 267.094C69.8366 267.435 69.7196 267.764 69.5202 268.041C69.3208 268.319 69.0472 268.535 68.7307 268.664C68.4141 268.794 68.0676 268.831 67.7306 268.773C67.3937 268.714 67.0801 268.562 66.8258 268.334C66.1677 267.993 65.6415 267.443 65.33 266.771Z",
    fill: "url(#paint348_linear_3875_2346)"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3404 270.192C71.0781 269.498 71.045 268.738 71.2461 268.024C71.2461 267.862 71.3674 267.593 71.4752 267.229L71.7312 266.421C71.8085 266.109 71.9536 265.818 72.1563 265.569C72.3589 265.32 72.6141 265.119 72.9036 264.98C73.2263 264.885 73.5661 264.866 73.8975 264.922C74.2289 264.978 74.5434 265.108 74.8171 265.303C75.2754 265.564 75.6783 265.911 76.003 266.327C76.2802 266.678 76.4738 267.088 76.569 267.525C76.6566 267.907 76.6566 268.303 76.569 268.684C76.569 268.684 76.569 268.778 76.4746 268.778C76.4512 268.788 76.426 268.793 76.4005 268.793C76.3751 268.793 76.3498 268.788 76.3264 268.778L75.9086 268.536C75.8579 268.501 75.8162 268.455 75.7874 268.401C75.7646 268.34 75.7646 268.273 75.7874 268.212C75.842 267.773 75.7621 267.326 75.5583 266.933C75.3251 266.568 74.9998 266.27 74.615 266.071C73.6313 265.505 72.944 265.788 72.5532 266.946C72.5532 267.108 72.4184 267.35 72.3241 267.687C72.2298 268.024 72.1489 268.293 72.095 268.468C71.9178 268.954 71.9224 269.488 72.1082 269.971C72.294 270.454 72.6483 270.853 73.1057 271.095C73.4326 271.31 73.8201 271.414 74.2107 271.391C74.3882 271.353 74.554 271.273 74.6946 271.159C74.8352 271.044 74.9464 270.897 75.0192 270.731C75.0192 270.664 75.1001 270.624 75.154 270.624C75.2019 270.606 75.2544 270.606 75.3023 270.624L75.72 270.866C75.7726 270.892 75.8151 270.935 75.8413 270.987C75.8609 271.039 75.8609 271.097 75.8413 271.149C75.7319 271.477 75.5251 271.763 75.2484 271.971C74.9564 272.184 74.5988 272.289 74.2377 272.267C73.7596 272.227 73.2978 272.075 72.8901 271.822C72.1986 271.477 71.6502 270.9 71.3404 270.192Z",
    fill: "url(#paint349_linear_3875_2346)"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9435 274.597C77.9301 274.568 77.9232 274.535 77.9232 274.503C77.9232 274.47 77.9301 274.438 77.9435 274.409L79.5471 269.021L77.9165 268.078C77.8872 268.066 77.861 268.048 77.8399 268.025C77.8189 268.001 77.8036 267.973 77.7953 267.943C77.7819 267.913 77.7749 267.881 77.7749 267.849C77.7749 267.816 77.7819 267.784 77.7953 267.754L77.903 267.404C77.9062 267.377 77.9166 267.352 77.9333 267.33C77.9499 267.309 77.9721 267.293 77.9974 267.283C78.0224 267.27 78.0501 267.263 78.0782 267.263C78.1064 267.263 78.1341 267.27 78.1591 267.283L82.2018 269.627C82.2553 269.658 82.2977 269.705 82.3231 269.761C82.3365 269.791 82.3434 269.823 82.3434 269.856C82.3434 269.888 82.3365 269.92 82.3231 269.95L82.2153 270.3C82.2121 270.327 82.2017 270.353 82.1851 270.374C82.1684 270.395 82.1463 270.412 82.121 270.421C82.096 270.434 82.0682 270.441 82.0401 270.441C82.012 270.441 81.9842 270.434 81.9592 270.421L80.3421 269.492L78.7385 274.88C78.7385 274.88 78.7386 274.974 78.6307 274.988C78.6058 275.001 78.578 275.008 78.5499 275.008C78.5217 275.008 78.494 275.001 78.469 274.988L78.0647 274.759C78.0321 274.745 78.0037 274.723 77.9825 274.694C77.9612 274.666 77.9477 274.632 77.9435 274.597Z",
    fill: "url(#paint350_linear_3875_2346)"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7706 276.766C81.7568 276.708 81.7568 276.648 81.7706 276.591L83.5494 270.664C83.5548 270.638 83.5662 270.613 83.5825 270.592C83.5989 270.571 83.6198 270.554 83.6437 270.543C83.6666 270.531 83.692 270.525 83.7178 270.525C83.7436 270.525 83.769 270.531 83.7919 270.543L84.2232 270.785C84.2767 270.816 84.3191 270.863 84.3444 270.92C84.3578 270.949 84.3647 270.982 84.3647 271.014C84.3647 271.047 84.3578 271.079 84.3444 271.108L82.5791 277.022C82.5791 277.089 82.5791 277.129 82.4713 277.143C82.4479 277.153 82.4227 277.158 82.3972 277.158C82.3717 277.158 82.3465 277.153 82.3231 277.143L81.8918 276.9C81.8394 276.868 81.7973 276.821 81.7706 276.766Z",
    fill: "url(#paint351_linear_3875_2346)"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7892 277.951C84.5026 277.238 84.474 276.447 84.7084 275.715C84.7084 275.527 84.8297 275.271 84.9375 274.934L85.1665 274.18C85.2361 273.852 85.384 273.546 85.5976 273.288C85.8111 273.03 86.084 272.828 86.3928 272.698C86.7075 272.612 87.0373 272.597 87.3587 272.652C87.6801 272.708 87.9852 272.834 88.2525 273.021C88.9135 273.377 89.4391 273.94 89.7483 274.624C90.0328 275.337 90.066 276.126 89.8426 276.86C89.7483 277.21 89.6675 277.466 89.627 277.628C89.5866 277.79 89.4922 278.032 89.3844 278.382C89.3144 278.709 89.1697 279.015 88.9616 279.277C88.7536 279.539 88.4878 279.749 88.1851 279.891C87.8641 279.973 87.529 279.984 87.2031 279.924C86.8773 279.864 86.5686 279.733 86.2985 279.541C85.6341 279.191 85.1035 278.633 84.7892 277.951ZM87.7404 278.975C87.9544 278.868 88.1417 278.714 88.2886 278.526C88.4355 278.337 88.5383 278.117 88.5894 277.884C88.7107 277.52 88.7781 277.291 88.8185 277.17C88.8589 277.049 88.9263 276.793 89.0206 276.429C89.1982 275.909 89.1982 275.346 89.0206 274.826C88.8375 274.374 88.5045 273.998 88.0773 273.762C87.8991 273.643 87.6964 273.565 87.4842 273.535C87.2719 273.504 87.0554 273.522 86.851 273.587C86.639 273.695 86.4538 273.849 86.3092 274.038C86.1646 274.226 86.0643 274.445 86.0155 274.678L85.7864 275.405C85.6966 275.702 85.6292 275.944 85.5843 276.133C85.4002 276.647 85.4002 277.208 85.5843 277.722C85.7638 278.181 86.1038 278.559 86.5411 278.786C86.7123 278.909 86.91 278.99 87.1183 279.023C87.3266 279.056 87.5397 279.039 87.7404 278.975Z",
    fill: "url(#paint352_linear_3875_2346)"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2064 281.615C90.193 281.585 90.186 281.553 90.186 281.521C90.186 281.488 90.193 281.456 90.2064 281.426L91.9717 275.513C91.9717 275.446 91.9717 275.405 92.066 275.392C92.091 275.379 92.1187 275.372 92.1469 275.372C92.175 275.372 92.2027 275.379 92.2277 275.392L92.605 275.607C92.6537 275.628 92.6923 275.666 92.7128 275.715C92.7204 275.76 92.7204 275.805 92.7128 275.85L94.1547 282.154L95.5023 277.574C95.5082 277.545 95.5211 277.517 95.5399 277.494C95.5586 277.47 95.5827 277.452 95.6101 277.439C95.6577 277.42 95.7107 277.42 95.7583 277.439L96.1357 277.655C96.1971 277.686 96.2451 277.739 96.2704 277.803C96.291 277.864 96.291 277.93 96.2704 277.992L94.4916 283.891C94.4916 283.891 94.4916 283.999 94.3973 284.013C94.3732 284.028 94.3451 284.037 94.3164 284.037C94.2877 284.037 94.2596 284.028 94.2356 284.013L93.8583 283.797C93.8135 283.773 93.7753 283.738 93.7471 283.696C93.7189 283.654 93.7015 283.605 93.6966 283.555L92.2412 277.305L90.8936 281.844C90.8879 281.872 90.8749 281.898 90.856 281.919C90.8371 281.94 90.8129 281.956 90.7858 281.965C90.7629 281.977 90.7375 281.983 90.7117 281.983C90.6859 281.983 90.6605 281.977 90.6376 281.965L90.2468 281.75C90.225 281.708 90.2113 281.662 90.2064 281.615Z",
    fill: "url(#paint353_linear_3875_2346)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9038 132.247L226.81 254.123V234.376L72.9038 112.514V132.247Z",
    fill: "#BCBEC0"
  }))), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9038 130.362L226.81 252.237V232.49L72.9038 110.615V130.362Z",
    fill: "url(#paint354_linear_3875_2346)"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8413 112.932L86.6219 141.218L104.235 155.16L93.4541 126.873L75.8413 112.932ZM113.883 143.037L124.664 171.323L142.304 185.292L131.523 157.005L113.883 143.037ZM207.593 217.256L189.954 203.274L200.734 231.561L218.36 245.543L207.593 217.256ZM151.912 173.155L162.692 201.442L180.359 215.41L169.578 187.124L151.912 173.155Z",
    fill: "url(#paint355_linear_3875_2346)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M226.567 253.113L226.782 254.567L341.407 119.572V98.9902L226.567 234.241V253.113Z",
    fill: "#BCBEC0"
  }))), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M226.567 250.755L226.782 252.197L341.407 117.201V96.6195L226.567 231.884V250.755Z",
    fill: "url(#paint356_linear_3875_2346)"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M270.242 200.957L279.877 189.602L283.152 165.168L273.517 176.523L270.242 200.957ZM291.035 176.469L300.67 165.114L303.945 140.693L294.296 152.048L291.035 176.469ZM311.815 151.994L321.463 140.639L324.738 116.205L315.116 127.614L311.815 151.994ZM335.882 103.072L332.635 127.56L341.434 117.202V96.6195L335.882 103.072ZM249.449 225.445L259.098 214.09L262.372 189.656L252.724 201.011L249.449 225.445ZM228.669 249.988L238.305 238.673L241.579 214.252L231.931 225.607L228.669 249.988Z",
    fill: "url(#paint357_linear_3875_2346)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0518 127.897L226.715 198.789V179.042L73.0518 108.163V127.897Z",
    fill: "#BCBEC0"
  }))), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0518 125.768L226.715 196.66V176.913L73.0518 106.035V125.768Z",
    fill: "url(#paint358_linear_3875_2346)"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M174.483 152.816L185.264 177.52L202.904 185.602L192.123 160.898L174.483 152.816ZM136.441 135.305L147.222 160.009L164.862 168.091L154.081 143.387L136.441 135.305ZM212.512 170.394L223.292 195.098L226.729 196.687V176.9L212.512 170.394ZM98.3994 117.767L109.18 142.471L126.82 150.553L116.039 125.849L98.3994 117.767ZM73.0381 106.062V125.809L88.7238 133.015L77.9433 108.311L73.0381 106.062Z",
    fill: "url(#paint359_linear_3875_2346)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M226.688 198.748L342 212.178V192.431L226.688 179.015V198.748Z",
    fill: "#BCBEC0"
  }))), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M226.688 196.62L342 210.049V190.303L226.688 176.873V196.62Z",
    fill: "url(#paint360_linear_3875_2346)"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M292.464 184.524L301.64 205.321L319.294 207.369L310.049 186.585L292.464 184.524ZM254.476 180.106L263.666 200.957L281.306 203.005L272.061 182.099L254.476 180.106ZM330.559 188.956L339.79 209.74L342.054 210.009V190.289L330.559 188.956ZM226.796 176.833V196.539L243.372 198.465L234.127 177.681L226.796 176.833Z",
    fill: "url(#paint361_linear_3875_2346)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3875_2346",
    x1: 176.046,
    y1: 285.844,
    x2: 418.686,
    y2: 213.157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3875_2346",
    x1: 16.8713,
    y1: 314.508,
    x2: 197.614,
    y2: 273.971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3875_2346",
    x1: 176.046,
    y1: 298.452,
    x2: 418.686,
    y2: 225.765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3875_2346",
    x1: 16.8713,
    y1: 327.103,
    x2: 197.614,
    y2: 286.579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3875_2346",
    x1: 278.677,
    y1: 35.0756,
    x2: 153.91,
    y2: 272.958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3875_2346",
    x1: 104.612,
    y1: 142.094,
    x2: 448.272,
    y2: 39.1426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3875_2346",
    x1: 165.091,
    y1: 181.776,
    x2: 472.154,
    y2: 89.7981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3875_2346",
    x1: -28.7978,
    y1: 218.441,
    x2: 252.348,
    y2: 155.391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3875_2346",
    x1: 263.652,
    y1: -129.89,
    x2: 152.176,
    y2: 82.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3875_2346",
    x1: 168.365,
    y1: 179.257,
    x2: 512.025,
    y2: 76.3195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3875_2346",
    x1: 278.677,
    y1: -169.559,
    x2: 153.91,
    y2: 68.3367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3875_2346",
    x1: 91.4169,
    y1: 81.7919,
    x2: 94.1251,
    y2: 81.7919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#138BBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#169AC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BB0D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3875_2346",
    x1: 95.2743,
    y1: 83.9921,
    x2: 97.9825,
    y2: 83.9921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#138BBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#169AC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BB0D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3875_2346",
    x1: 87.5597,
    y1: 79.5605,
    x2: 90.2679,
    y2: 79.5605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FFA98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFB892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FEE1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEECA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3875_2346",
    x1: 128.078,
    y1: 102.837,
    x2: 134.831,
    y2: 102.837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#138BBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#169AC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BB0D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3875_2346",
    x1: 99.1197,
    y1: 86.2012,
    x2: 126.94,
    y2: 86.2012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#138BBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#169AC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BB0D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_3875_2346",
    x1: 83.4097,
    y1: 77.1764,
    x2: 86.4228,
    y2: 77.1764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#138BBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#169AC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BB0D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_3875_2346",
    x1: 91.4169,
    y1: 89.7694,
    x2: 94.1251,
    y2: 89.7694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#1A86BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#1F95C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26ACD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_3875_2346",
    x1: 95.2743,
    y1: 91.9852,
    x2: 97.9825,
    y2: 91.9852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#1A86BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#1F95C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26ACD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_3875_2346",
    x1: 87.5597,
    y1: 87.5536,
    x2: 90.2679,
    y2: 87.5536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FAA28D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FBB194"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FDDAA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_3875_2346",
    x1: 128.078,
    y1: 110.83,
    x2: 134.831,
    y2: 110.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#1A86BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#1F95C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26ACD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_3875_2346",
    x1: 99.1197,
    y1: 94.1942,
    x2: 126.94,
    y2: 94.1942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#1A86BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#1F95C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26ACD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_3875_2346",
    x1: 83.4097,
    y1: 85.1694,
    x2: 86.4228,
    y2: 85.1694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#1A86BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#1F95C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26ACD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_3875_2346",
    x1: 91.4169,
    y1: 97.7469,
    x2: 94.1251,
    y2: 97.7469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#2080BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#268FC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31A9D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_3875_2346",
    x1: 95.2743,
    y1: 99.9627,
    x2: 97.9825,
    y2: 99.9627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#2080BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#268FC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31A9D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_3875_2346",
    x1: 87.5597,
    y1: 95.5311,
    x2: 90.2679,
    y2: 95.5311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#F69B8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#F8AA96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FDD3A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEDFAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_3875_2346",
    x1: 128.078,
    y1: 118.807,
    x2: 134.831,
    y2: 118.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#2080BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#268FC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31A9D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_3875_2346",
    x1: 99.1197,
    y1: 102.172,
    x2: 126.94,
    y2: 102.172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#2080BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#268FC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31A9D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_3875_2346",
    x1: 83.4097,
    y1: 93.147,
    x2: 86.4228,
    y2: 93.147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#2080BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#268FC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31A9D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_3875_2346",
    x1: 91.4169,
    y1: 105.724,
    x2: 94.1251,
    y2: 105.724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#277BBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#2F8AC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3CA5D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_3875_2346",
    x1: 95.2743,
    y1: 107.94,
    x2: 97.9825,
    y2: 107.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#277BBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#2F8AC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3CA5D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_3875_2346",
    x1: 87.5597,
    y1: 103.509,
    x2: 90.2679,
    y2: 103.509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#F19490"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#F4A397"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FCCCA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED8AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_3875_2346",
    x1: 128.078,
    y1: 126.785,
    x2: 134.831,
    y2: 126.785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#277BBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#2F8AC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3CA5D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_3875_2346",
    x1: 99.1197,
    y1: 110.149,
    x2: 126.94,
    y2: 110.149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#277BBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#2F8AC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3CA5D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_3875_2346",
    x1: 83.4097,
    y1: 101.124,
    x2: 86.4228,
    y2: 101.124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#277BBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#2F8AC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3CA5D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_3875_2346",
    x1: 91.4169,
    y1: 113.717,
    x2: 94.1251,
    y2: 113.717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#2E75BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3684C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46A1D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_3875_2346",
    x1: 95.2743,
    y1: 115.933,
    x2: 97.9825,
    y2: 115.933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#2E75BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3684C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46A1D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_3875_2346",
    x1: 87.5597,
    y1: 111.502,
    x2: 90.2679,
    y2: 111.502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ED8E92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#F19D99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FBC6AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED2AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_3875_2346",
    x1: 128.078,
    y1: 134.778,
    x2: 134.831,
    y2: 134.778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#2E75BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3684C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46A1D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_3875_2346",
    x1: 99.1197,
    y1: 118.142,
    x2: 126.94,
    y2: 118.142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#2E75BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3684C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46A1D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_3875_2346",
    x1: 83.4097,
    y1: 109.118,
    x2: 86.4228,
    y2: 109.118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#2E75BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3684C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46A1D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_3875_2346",
    x1: 91.4169,
    y1: 121.695,
    x2: 94.1251,
    y2: 121.695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#3470B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#3E7FC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#519ED3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_3875_2346",
    x1: 95.2743,
    y1: 123.911,
    x2: 97.9825,
    y2: 123.911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#3470B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#3E7FC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#519ED3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_3875_2346",
    x1: 87.5597,
    y1: 119.479,
    x2: 90.2679,
    y2: 119.479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#E88793"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#ED969A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FABFAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECBB1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_3875_2346",
    x1: 128.078,
    y1: 142.755,
    x2: 134.831,
    y2: 142.755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#3470B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#3E7FC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#519ED3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_3875_2346",
    x1: 99.1197,
    y1: 126.12,
    x2: 126.94,
    y2: 126.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#3470B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#3E7FC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#519ED3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_3875_2346",
    x1: 83.4097,
    y1: 117.095,
    x2: 86.4228,
    y2: 117.095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#3470B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#3E7FC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#519ED3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_3875_2346",
    x1: 91.4169,
    y1: 129.673,
    x2: 94.1251,
    y2: 129.673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#3B6AB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#4679C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C9AD2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_3875_2346",
    x1: 95.2743,
    y1: 131.888,
    x2: 97.9825,
    y2: 131.888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#3B6AB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#4679C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C9AD2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_3875_2346",
    x1: 87.5597,
    y1: 127.457,
    x2: 90.2679,
    y2: 127.457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#E48095"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#EA8F9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#F9B8AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEC5B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_3875_2346",
    x1: 128.078,
    y1: 150.733,
    x2: 134.831,
    y2: 150.733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#3B6AB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#4679C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C9AD2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_3875_2346",
    x1: 99.1197,
    y1: 134.097,
    x2: 126.94,
    y2: 134.097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#3B6AB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#4679C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C9AD2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_3875_2346",
    x1: 83.4097,
    y1: 125.073,
    x2: 86.4228,
    y2: 125.073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#3B6AB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#4679C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C9AD2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_3875_2346",
    x1: 91.4169,
    y1: 137.666,
    x2: 94.1251,
    y2: 137.666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#4265B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#4E74BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6796D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_3875_2346",
    x1: 95.2743,
    y1: 139.881,
    x2: 97.9825,
    y2: 139.881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#4265B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#4E74BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6796D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_3875_2346",
    x1: 87.5597,
    y1: 135.45,
    x2: 90.2679,
    y2: 135.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#DF7996"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E6889D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#F8B1AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEBEB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_3875_2346",
    x1: 128.078,
    y1: 158.726,
    x2: 134.831,
    y2: 158.726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#4265B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#4E74BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6796D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_3875_2346",
    x1: 99.1197,
    y1: 142.09,
    x2: 126.94,
    y2: 142.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#4265B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#4E74BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6796D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_3875_2346",
    x1: 83.4097,
    y1: 133.066,
    x2: 86.4228,
    y2: 133.066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#4265B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#4E74BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6796D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_3875_2346",
    x1: 91.4169,
    y1: 145.643,
    x2: 94.1251,
    y2: 145.643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#4860B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#556FBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7293D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_3875_2346",
    x1: 95.2743,
    y1: 147.859,
    x2: 97.9825,
    y2: 147.859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#4860B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#556FBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7293D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_3875_2346",
    x1: 87.5597,
    y1: 143.427,
    x2: 90.2679,
    y2: 143.427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#DA7298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E2819F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F7AAB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB8B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_3875_2346",
    x1: 128.078,
    y1: 166.703,
    x2: 134.831,
    y2: 166.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#4860B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#556FBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7293D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_3875_2346",
    x1: 99.1197,
    y1: 150.068,
    x2: 126.94,
    y2: 150.068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#4860B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#556FBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7293D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_3875_2346",
    x1: 83.4097,
    y1: 141.043,
    x2: 86.4228,
    y2: 141.043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#4860B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#556FBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7293D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_3875_2346",
    x1: 91.4169,
    y1: 153.621,
    x2: 94.1251,
    y2: 153.621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#4F5AB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#5C69BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D8FD1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_3875_2346",
    x1: 95.2743,
    y1: 155.836,
    x2: 97.9825,
    y2: 155.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#4F5AB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#5C69BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D8FD1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_3875_2346",
    x1: 87.5597,
    y1: 151.405,
    x2: 90.2679,
    y2: 151.405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#D66B99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#DF7AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F6A3B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB1B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_3875_2346",
    x1: 128.078,
    y1: 174.681,
    x2: 134.831,
    y2: 174.681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#4F5AB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#5C69BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D8FD1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_3875_2346",
    x1: 99.1197,
    y1: 158.046,
    x2: 126.94,
    y2: 158.046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#4F5AB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#5C69BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D8FD1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_3875_2346",
    x1: 83.4097,
    y1: 149.021,
    x2: 86.4228,
    y2: 149.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#4F5AB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#5C69BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D8FD1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_3875_2346",
    x1: 91.4169,
    y1: 161.614,
    x2: 94.1251,
    y2: 161.614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#5655B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#6464BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#888BD1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_3875_2346",
    x1: 95.2743,
    y1: 163.829,
    x2: 97.9825,
    y2: 163.829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#5655B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#6464BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#888BD1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_3875_2346",
    x1: 87.5597,
    y1: 159.398,
    x2: 90.2679,
    y2: 159.398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#D1649B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#DB73A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#F49CB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEABBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_3875_2346",
    x1: 128.078,
    y1: 182.658,
    x2: 134.831,
    y2: 182.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#5655B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#6464BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#888BD1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_3875_2346",
    x1: 99.1197,
    y1: 166.023,
    x2: 126.94,
    y2: 166.023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#5655B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#6464BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#888BD1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_3875_2346",
    x1: 83.4097,
    y1: 156.998,
    x2: 86.4228,
    y2: 156.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#5655B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#6464BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#888BD1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_3875_2346",
    x1: 91.4169,
    y1: 169.591,
    x2: 94.1251,
    y2: 169.591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#5C4FB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#6B5EBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9187D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9288D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_3875_2346",
    x1: 95.2743,
    y1: 171.807,
    x2: 97.9825,
    y2: 171.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#5C4FB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#6B5EBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9187D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9288D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_3875_2346",
    x1: 87.5597,
    y1: 167.375,
    x2: 90.2679,
    y2: 167.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#CD5E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#D86DA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F596B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA4BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_3875_2346",
    x1: 128.078,
    y1: 190.651,
    x2: 134.831,
    y2: 190.651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#5C4FB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#6B5EBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9187D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9288D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_3875_2346",
    x1: 99.1197,
    y1: 174.016,
    x2: 126.94,
    y2: 174.016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#5C4FB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#6B5EBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9187D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9288D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_3875_2346",
    x1: 83.4097,
    y1: 164.991,
    x2: 86.4228,
    y2: 164.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#5C4FB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#6B5EBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9187D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9288D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_3875_2346",
    x1: 91.4169,
    y1: 177.569,
    x2: 94.1251,
    y2: 177.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#634AB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#7259BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#9B82D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D84D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_3875_2346",
    x1: 95.2743,
    y1: 179.785,
    x2: 97.9825,
    y2: 179.785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#634AB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#7259BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#9B82D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D84D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_3875_2346",
    x1: 87.5597,
    y1: 175.353,
    x2: 90.2679,
    y2: 175.353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#C8579E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#D466A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#F38FB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9EBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_3875_2346",
    x1: 128.078,
    y1: 198.629,
    x2: 134.831,
    y2: 198.629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#634AB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#7259BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#9B82D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D84D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_3875_2346",
    x1: 99.1197,
    y1: 181.994,
    x2: 126.94,
    y2: 181.994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#634AB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#7259BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#9B82D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D84D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_3875_2346",
    x1: 83.4097,
    y1: 172.969,
    x2: 86.4228,
    y2: 172.969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#634AB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#7259BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#9B82D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D84D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_3875_2346",
    x1: 91.4169,
    y1: 185.546,
    x2: 94.1251,
    y2: 185.546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#6A44B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#7953B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#A27ACD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A880D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_3875_2346",
    x1: 95.2743,
    y1: 187.762,
    x2: 97.9825,
    y2: 187.762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#6A44B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#7953B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#A27ACD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A880D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_3875_2346",
    x1: 87.5597,
    y1: 183.331,
    x2: 90.2679,
    y2: 183.331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#C4509F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#D15FA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#F288B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF97C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_3875_2346",
    x1: 128.078,
    y1: 206.606,
    x2: 134.831,
    y2: 206.606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#6A44B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#7953B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#A27ACD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A880D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_3875_2346",
    x1: 99.1197,
    y1: 189.971,
    x2: 126.94,
    y2: 189.971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#6A44B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#7953B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#A27ACD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A880D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_3875_2346",
    x1: 83.4097,
    y1: 180.946,
    x2: 86.4228,
    y2: 180.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#6A44B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#7953B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#A27ACD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A880D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_3875_2346",
    x1: 91.4169,
    y1: 193.539,
    x2: 94.1251,
    y2: 193.539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#703FB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#7F4DB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#A872CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B37DD0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_3875_2346",
    x1: 95.2743,
    y1: 195.755,
    x2: 97.9825,
    y2: 195.755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#703FB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#7F4DB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#A872CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B37DD0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_3875_2346",
    x1: 87.5597,
    y1: 191.324,
    x2: 90.2679,
    y2: 191.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#BF49A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#CD58A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#F081BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF91C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_3875_2346",
    x1: 128.078,
    y1: 214.6,
    x2: 134.831,
    y2: 214.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#703FB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#7F4DB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#A872CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B37DD0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_3875_2346",
    x1: 99.1197,
    y1: 197.964,
    x2: 126.94,
    y2: 197.964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#703FB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#7F4DB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#A872CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B37DD0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_3875_2346",
    x1: 83.4097,
    y1: 188.939,
    x2: 86.4228,
    y2: 188.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#703FB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#7F4DB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#A872CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B37DD0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_3875_2346",
    x1: 91.4169,
    y1: 201.517,
    x2: 94.1251,
    y2: 201.517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#773AB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#8648B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#AF6BC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE79D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_3875_2346",
    x1: 95.2743,
    y1: 203.733,
    x2: 97.9825,
    y2: 203.733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#773AB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#8648B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#AF6BC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE79D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_3875_2346",
    x1: 87.5597,
    y1: 199.301,
    x2: 90.2679,
    y2: 199.301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#BA42A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#C951A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#EF7ABB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8AC3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_3875_2346",
    x1: 128.078,
    y1: 222.577,
    x2: 134.831,
    y2: 222.577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#773AB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#8648B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#AF6BC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE79D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_3875_2346",
    x1: 99.1197,
    y1: 205.942,
    x2: 126.94,
    y2: 205.942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#773AB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#8648B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#AF6BC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE79D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_3875_2346",
    x1: 83.4097,
    y1: 196.917,
    x2: 86.4228,
    y2: 196.917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#773AB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#8648B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#AF6BC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE79D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_3875_2346",
    x1: 91.4169,
    y1: 209.494,
    x2: 94.1251,
    y2: 209.494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#7E34AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#8D41B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#B664C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C975CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_3875_2346",
    x1: 95.2743,
    y1: 211.71,
    x2: 97.9825,
    y2: 211.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#7E34AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#8D41B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#B664C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C975CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_3875_2346",
    x1: 87.5597,
    y1: 207.279,
    x2: 90.2679,
    y2: 207.279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#B63BA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#C54AAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#EE73BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF84C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_3875_2346",
    x1: 128.078,
    y1: 230.555,
    x2: 134.831,
    y2: 230.555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#7E34AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#8D41B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#B664C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C975CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_3875_2346",
    x1: 99.1197,
    y1: 213.919,
    x2: 126.94,
    y2: 213.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#7E34AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#8D41B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#B664C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C975CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_3875_2346",
    x1: 83.4097,
    y1: 204.894,
    x2: 86.4228,
    y2: 204.894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#7E34AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#8D41B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#B664C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C975CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_3875_2346",
    x1: 91.4169,
    y1: 217.487,
    x2: 94.1251,
    y2: 217.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#842FAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#933CB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#BC5EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D472CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_3875_2346",
    x1: 95.2743,
    y1: 219.703,
    x2: 97.9825,
    y2: 219.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#842FAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#933CB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#BC5EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D472CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_3875_2346",
    x1: 87.5597,
    y1: 215.272,
    x2: 90.2679,
    y2: 215.272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#B134A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#C042AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#E968BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7DC7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_3875_2346",
    x1: 128.078,
    y1: 238.548,
    x2: 134.831,
    y2: 238.548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#842FAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#933CB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#BC5EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D472CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_3875_2346",
    x1: 99.1197,
    y1: 221.912,
    x2: 126.94,
    y2: 221.912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#842FAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#933CB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#BC5EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D472CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_3875_2346",
    x1: 83.4097,
    y1: 212.887,
    x2: 86.4228,
    y2: 212.887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#842FAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#933CB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#BC5EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D472CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_3875_2346",
    x1: 91.4169,
    y1: 225.465,
    x2: 94.1251,
    y2: 225.465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#8B29AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#9A36B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#C357C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE6ECF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_3875_2346",
    x1: 95.2743,
    y1: 227.681,
    x2: 97.9825,
    y2: 227.681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#8B29AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#9A36B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#C357C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE6ECF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_3875_2346",
    x1: 87.5597,
    y1: 223.249,
    x2: 90.2679,
    y2: 223.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#AD2EA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#BC3CAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#E55FBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF77C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_3875_2346",
    x1: 128.078,
    y1: 246.525,
    x2: 134.831,
    y2: 246.525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#8B29AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#9A36B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#C357C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE6ECF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_3875_2346",
    x1: 99.1197,
    y1: 229.89,
    x2: 126.94,
    y2: 229.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#8B29AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#9A36B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#C357C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE6ECF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_3875_2346",
    x1: 83.4097,
    y1: 220.865,
    x2: 86.4228,
    y2: 220.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#8B29AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#9A36B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#C357C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE6ECF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_3875_2346",
    x1: 91.4169,
    y1: 233.443,
    x2: 94.1251,
    y2: 233.443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9224AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#A130B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#CA51C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E96ACF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_3875_2346",
    x1: 95.2743,
    y1: 235.658,
    x2: 97.9825,
    y2: 235.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9224AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#A130B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#CA51C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E96ACF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_3875_2346",
    x1: 87.5597,
    y1: 231.227,
    x2: 90.2679,
    y2: 231.227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#A827A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#B734AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E056BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF70CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_3875_2346",
    x1: 128.078,
    y1: 254.503,
    x2: 134.831,
    y2: 254.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9224AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#A130B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#CA51C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E96ACF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_3875_2346",
    x1: 99.1197,
    y1: 237.867,
    x2: 126.94,
    y2: 237.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9224AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#A130B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#CA51C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E96ACF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_3875_2346",
    x1: 83.4097,
    y1: 228.843,
    x2: 86.4228,
    y2: 228.843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9224AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#A130B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#CA51C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E96ACF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_3875_2346",
    x1: 91.4169,
    y1: 241.436,
    x2: 94.1251,
    y2: 241.436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#981EAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A72AB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#D04AC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F467CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_3875_2346",
    x1: 95.2743,
    y1: 243.651,
    x2: 97.9825,
    y2: 243.651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#981EAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A72AB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#D04AC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F467CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_3875_2346",
    x1: 87.5597,
    y1: 239.22,
    x2: 90.2679,
    y2: 239.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#A420AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#B32DB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#DC4DBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6ACC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_3875_2346",
    x1: 128.078,
    y1: 262.496,
    x2: 134.831,
    y2: 262.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#981EAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A72AB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#D04AC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F467CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_3875_2346",
    x1: 99.1197,
    y1: 245.86,
    x2: 126.94,
    y2: 245.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#981EAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A72AB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#D04AC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F467CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_3875_2346",
    x1: 83.4097,
    y1: 236.836,
    x2: 86.4228,
    y2: 236.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#981EAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A72AB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#D04AC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F467CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_3875_2346",
    x1: 91.4169,
    y1: 249.413,
    x2: 94.1251,
    y2: 249.413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D744BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_3875_2346",
    x1: 95.2743,
    y1: 251.629,
    x2: 97.9825,
    y2: 251.629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D744BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_3875_2346",
    x1: 87.5597,
    y1: 247.197,
    x2: 90.2679,
    y2: 247.197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D744BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_3875_2346",
    x1: 128.078,
    y1: 270.473,
    x2: 134.831,
    y2: 270.473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D744BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_3875_2346",
    x1: 99.1197,
    y1: 253.838,
    x2: 126.94,
    y2: 253.838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D744BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_3875_2346",
    x1: 83.4097,
    y1: 244.813,
    x2: 86.4228,
    y2: 244.813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D744BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_3875_2346",
    x1: 79.062,
    y1: 185.817,
    x2: 131.496,
    y2: 185.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#138BBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#169AC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1FC3DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_3875_2346",
    x1: -48.6341,
    y1: 220.3,
    x2: 266.011,
    y2: 149.727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_3875_2346",
    x1: 139.042,
    y1: 285.4,
    x2: 80.1182,
    y2: 111.421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#364F87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#263860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#19243D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#0E1422"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#06090F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#020204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_3875_2346",
    x1: 100.34,
    y1: 69.9895,
    x2: 108.149,
    y2: 147.388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#972A74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#8A266A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#601B4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3D112F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#230A1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0F040C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#040103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_3875_2346",
    x1: 265.552,
    y1: 316.152,
    x2: 508.192,
    y2: 243.464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_3875_2346",
    x1: 106.364,
    y1: 344.802,
    x2: 287.119,
    y2: 304.265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_3875_2346",
    x1: 265.552,
    y1: 328.746,
    x2: 508.192,
    y2: 256.059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_3875_2346",
    x1: 106.364,
    y1: 357.41,
    x2: 287.119,
    y2: 316.873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_3875_2346",
    x1: 368.183,
    y1: 65.3559,
    x2: 243.402,
    y2: 303.251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_3875_2346",
    x1: 194.118,
    y1: 172.388,
    x2: 537.778,
    y2: 69.4364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_3875_2346",
    x1: 254.597,
    y1: 212.07,
    x2: 561.659,
    y2: 120.092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_3875_2346",
    x1: 60.7081,
    y1: 248.735,
    x2: 341.84,
    y2: 185.684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_3875_2346",
    x1: 353.158,
    y1: -99.5963,
    x2: 241.668,
    y2: 112.958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_3875_2346",
    x1: 257.871,
    y1: 209.551,
    x2: 601.531,
    y2: 106.613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_3875_2346",
    x1: 368.183,
    y1: -139.265,
    x2: 243.402,
    y2: 98.6305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear_3875_2346",
    x1: 181.327,
    y1: 112.158,
    x2: 184.047,
    y2: 112.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#138BBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#169AC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BB0D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear_3875_2346",
    x1: 185.184,
    y1: 114.374,
    x2: 187.893,
    y2: 114.374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#138BBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#169AC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BB0D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear_3875_2346",
    x1: 177.482,
    y1: 109.949,
    x2: 180.19,
    y2: 109.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FFA98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFB892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FEE1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEECA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_3875_2346",
    x1: 218,
    y1: 133.225,
    x2: 224.741,
    y2: 133.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#138BBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#169AC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BB0D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint162_linear_3875_2346",
    x1: 189.042,
    y1: 116.59,
    x2: 216.851,
    y2: 116.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#138BBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#169AC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BB0D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_3875_2346",
    x1: 173.332,
    y1: 107.565,
    x2: 176.333,
    y2: 107.565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#138BBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#169AC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BB0D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear_3875_2346",
    x1: 181.327,
    y1: 120.151,
    x2: 184.047,
    y2: 120.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#1A86BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#1F95C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26ACD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear_3875_2346",
    x1: 185.184,
    y1: 122.367,
    x2: 187.893,
    y2: 122.367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#1A86BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#1F95C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26ACD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear_3875_2346",
    x1: 177.482,
    y1: 117.942,
    x2: 180.19,
    y2: 117.942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FAA28D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FBB194"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FDDAA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear_3875_2346",
    x1: 218,
    y1: 141.203,
    x2: 224.741,
    y2: 141.203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#1A86BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#1F95C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26ACD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint168_linear_3875_2346",
    x1: 189.042,
    y1: 124.583,
    x2: 216.851,
    y2: 124.583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#1A86BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#1F95C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26ACD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint169_linear_3875_2346",
    x1: 173.332,
    y1: 115.543,
    x2: 176.333,
    y2: 115.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#1A86BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#1F95C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26ACD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint170_linear_3875_2346",
    x1: 181.327,
    y1: 128.129,
    x2: 184.047,
    y2: 128.129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#2080BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#268FC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31A9D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear_3875_2346",
    x1: 185.184,
    y1: 130.345,
    x2: 187.893,
    y2: 130.345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#2080BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#268FC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31A9D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear_3875_2346",
    x1: 177.482,
    y1: 125.92,
    x2: 180.19,
    y2: 125.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#F69B8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#F8AA96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FDD3A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEDFAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint173_linear_3875_2346",
    x1: 218,
    y1: 149.196,
    x2: 224.741,
    y2: 149.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#2080BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#268FC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31A9D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint174_linear_3875_2346",
    x1: 189.042,
    y1: 132.561,
    x2: 216.851,
    y2: 132.561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#2080BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#268FC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31A9D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint175_linear_3875_2346",
    x1: 173.332,
    y1: 123.536,
    x2: 176.333,
    y2: 123.536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#2080BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#268FC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31A9D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint176_linear_3875_2346",
    x1: 181.327,
    y1: 136.106,
    x2: 184.047,
    y2: 136.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#277BBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#2F8AC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3CA5D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint177_linear_3875_2346",
    x1: 185.184,
    y1: 138.322,
    x2: 187.893,
    y2: 138.322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#277BBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#2F8AC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3CA5D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint178_linear_3875_2346",
    x1: 177.482,
    y1: 133.897,
    x2: 180.19,
    y2: 133.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#F19490"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#F4A397"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FCCCA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED8AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint179_linear_3875_2346",
    x1: 218,
    y1: 157.173,
    x2: 224.741,
    y2: 157.173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#277BBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#2F8AC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3CA5D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint180_linear_3875_2346",
    x1: 189.042,
    y1: 140.538,
    x2: 216.851,
    y2: 140.538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#277BBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#2F8AC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3CA5D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint181_linear_3875_2346",
    x1: 173.332,
    y1: 131.513,
    x2: 176.333,
    y2: 131.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#277BBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#2F8AC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3CA5D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint182_linear_3875_2346",
    x1: 181.327,
    y1: 144.084,
    x2: 184.047,
    y2: 144.084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#2E75BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3684C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46A1D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint183_linear_3875_2346",
    x1: 185.184,
    y1: 146.3,
    x2: 187.893,
    y2: 146.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#2E75BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3684C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46A1D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint184_linear_3875_2346",
    x1: 177.482,
    y1: 141.875,
    x2: 180.19,
    y2: 141.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ED8E92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#F19D99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FBC6AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED2AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint185_linear_3875_2346",
    x1: 218,
    y1: 165.151,
    x2: 224.741,
    y2: 165.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#2E75BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3684C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46A1D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint186_linear_3875_2346",
    x1: 189.042,
    y1: 148.516,
    x2: 216.851,
    y2: 148.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#2E75BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3684C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46A1D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint187_linear_3875_2346",
    x1: 173.332,
    y1: 139.491,
    x2: 176.333,
    y2: 139.491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#2E75BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3684C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46A1D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint188_linear_3875_2346",
    x1: 181.327,
    y1: 152.077,
    x2: 184.047,
    y2: 152.077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#3470B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#3E7FC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#519ED3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint189_linear_3875_2346",
    x1: 185.184,
    y1: 154.293,
    x2: 187.893,
    y2: 154.293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#3470B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#3E7FC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#519ED3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint190_linear_3875_2346",
    x1: 177.482,
    y1: 149.868,
    x2: 180.19,
    y2: 149.868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#E88793"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#ED969A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FABFAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECBB1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint191_linear_3875_2346",
    x1: 218,
    y1: 173.144,
    x2: 224.741,
    y2: 173.144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#3470B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#3E7FC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#519ED3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint192_linear_3875_2346",
    x1: 189.042,
    y1: 156.509,
    x2: 216.851,
    y2: 156.509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#3470B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#3E7FC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#519ED3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint193_linear_3875_2346",
    x1: 173.332,
    y1: 147.484,
    x2: 176.333,
    y2: 147.484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#3470B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#3E7FC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#519ED3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint194_linear_3875_2346",
    x1: 181.327,
    y1: 160.055,
    x2: 184.047,
    y2: 160.055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#3B6AB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#4679C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C9AD2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint195_linear_3875_2346",
    x1: 185.184,
    y1: 162.27,
    x2: 187.893,
    y2: 162.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#3B6AB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#4679C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C9AD2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint196_linear_3875_2346",
    x1: 177.482,
    y1: 157.846,
    x2: 180.19,
    y2: 157.846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#E48095"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#EA8F9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#F9B8AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEC5B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint197_linear_3875_2346",
    x1: 218,
    y1: 181.122,
    x2: 224.741,
    y2: 181.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#3B6AB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#4679C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C9AD2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint198_linear_3875_2346",
    x1: 189.042,
    y1: 164.486,
    x2: 216.851,
    y2: 164.486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#3B6AB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#4679C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C9AD2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint199_linear_3875_2346",
    x1: 173.332,
    y1: 155.461,
    x2: 176.333,
    y2: 155.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#3B6AB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#4679C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C9AD2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint200_linear_3875_2346",
    x1: 181.327,
    y1: 168.032,
    x2: 184.047,
    y2: 168.032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#4265B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#4E74BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6796D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint201_linear_3875_2346",
    x1: 185.184,
    y1: 170.248,
    x2: 187.893,
    y2: 170.248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#4265B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#4E74BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6796D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint202_linear_3875_2346",
    x1: 177.482,
    y1: 165.823,
    x2: 180.19,
    y2: 165.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#DF7996"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E6889D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#F8B1AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEBEB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint203_linear_3875_2346",
    x1: 218,
    y1: 189.099,
    x2: 224.741,
    y2: 189.099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#4265B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#4E74BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6796D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint204_linear_3875_2346",
    x1: 189.042,
    y1: 172.464,
    x2: 216.851,
    y2: 172.464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#4265B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#4E74BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6796D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint205_linear_3875_2346",
    x1: 173.332,
    y1: 163.439,
    x2: 176.333,
    y2: 163.439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#4265B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#4E74BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6796D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint206_linear_3875_2346",
    x1: 181.327,
    y1: 176.025,
    x2: 184.047,
    y2: 176.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#4860B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#556FBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7293D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint207_linear_3875_2346",
    x1: 185.184,
    y1: 178.241,
    x2: 187.893,
    y2: 178.241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#4860B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#556FBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7293D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint208_linear_3875_2346",
    x1: 177.482,
    y1: 173.816,
    x2: 180.19,
    y2: 173.816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#DA7298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E2819F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F7AAB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB8B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint209_linear_3875_2346",
    x1: 218,
    y1: 197.092,
    x2: 224.741,
    y2: 197.092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#4860B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#556FBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7293D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint210_linear_3875_2346",
    x1: 189.042,
    y1: 180.457,
    x2: 216.851,
    y2: 180.457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#4860B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#556FBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7293D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint211_linear_3875_2346",
    x1: 173.332,
    y1: 171.432,
    x2: 176.333,
    y2: 171.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#4860B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#556FBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7293D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint212_linear_3875_2346",
    x1: 181.327,
    y1: 184.003,
    x2: 184.047,
    y2: 184.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#4F5AB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#5C69BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D8FD1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint213_linear_3875_2346",
    x1: 185.184,
    y1: 186.218,
    x2: 187.893,
    y2: 186.218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#4F5AB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#5C69BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D8FD1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint214_linear_3875_2346",
    x1: 177.482,
    y1: 181.794,
    x2: 180.19,
    y2: 181.794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#D66B99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#DF7AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F6A3B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB1B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint215_linear_3875_2346",
    x1: 218,
    y1: 205.07,
    x2: 224.741,
    y2: 205.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#4F5AB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#5C69BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D8FD1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint216_linear_3875_2346",
    x1: 189.042,
    y1: 188.434,
    x2: 216.851,
    y2: 188.434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#4F5AB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#5C69BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D8FD1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint217_linear_3875_2346",
    x1: 173.332,
    y1: 179.409,
    x2: 176.333,
    y2: 179.409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#4F5AB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#5C69BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D8FD1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint218_linear_3875_2346",
    x1: 181.327,
    y1: 191.98,
    x2: 184.047,
    y2: 191.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#5655B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#6464BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#888BD1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint219_linear_3875_2346",
    x1: 185.184,
    y1: 194.196,
    x2: 187.893,
    y2: 194.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#5655B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#6464BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#888BD1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint220_linear_3875_2346",
    x1: 177.482,
    y1: 189.771,
    x2: 180.19,
    y2: 189.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#D1649B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#DB73A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#F49CB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEABBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint221_linear_3875_2346",
    x1: 218,
    y1: 213.047,
    x2: 224.741,
    y2: 213.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#5655B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#6464BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#888BD1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint222_linear_3875_2346",
    x1: 189.042,
    y1: 196.412,
    x2: 216.851,
    y2: 196.412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#5655B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#6464BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#888BD1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint223_linear_3875_2346",
    x1: 173.332,
    y1: 187.387,
    x2: 176.333,
    y2: 187.387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#5655B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#6464BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#888BD1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint224_linear_3875_2346",
    x1: 181.327,
    y1: 199.973,
    x2: 184.047,
    y2: 199.973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#5C4FB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#6B5EBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9187D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9288D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint225_linear_3875_2346",
    x1: 185.184,
    y1: 202.189,
    x2: 187.893,
    y2: 202.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#5C4FB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#6B5EBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9187D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9288D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint226_linear_3875_2346",
    x1: 177.482,
    y1: 197.764,
    x2: 180.19,
    y2: 197.764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#CD5E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#D86DA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F596B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA4BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint227_linear_3875_2346",
    x1: 218,
    y1: 221.04,
    x2: 224.741,
    y2: 221.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#5C4FB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#6B5EBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9187D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9288D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint228_linear_3875_2346",
    x1: 189.042,
    y1: 204.405,
    x2: 216.851,
    y2: 204.405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#5C4FB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#6B5EBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9187D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9288D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint229_linear_3875_2346",
    x1: 173.332,
    y1: 195.38,
    x2: 176.333,
    y2: 195.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#5C4FB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#6B5EBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9187D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9288D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint230_linear_3875_2346",
    x1: 181.327,
    y1: 207.951,
    x2: 184.047,
    y2: 207.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#634AB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#7259BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#9B82D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D84D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint231_linear_3875_2346",
    x1: 185.184,
    y1: 210.167,
    x2: 187.893,
    y2: 210.167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#634AB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#7259BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#9B82D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D84D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint232_linear_3875_2346",
    x1: 177.482,
    y1: 205.742,
    x2: 180.19,
    y2: 205.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#C8579E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#D466A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#F38FB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9EBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint233_linear_3875_2346",
    x1: 218,
    y1: 229.018,
    x2: 224.741,
    y2: 229.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#634AB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#7259BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#9B82D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D84D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint234_linear_3875_2346",
    x1: 189.042,
    y1: 212.382,
    x2: 216.851,
    y2: 212.382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#634AB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#7259BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#9B82D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D84D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint235_linear_3875_2346",
    x1: 173.332,
    y1: 203.358,
    x2: 176.333,
    y2: 203.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#634AB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#7259BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#9B82D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D84D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint236_linear_3875_2346",
    x1: 181.327,
    y1: 215.928,
    x2: 184.047,
    y2: 215.928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#6A44B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#7953B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#A27ACD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A880D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint237_linear_3875_2346",
    x1: 185.184,
    y1: 218.144,
    x2: 187.893,
    y2: 218.144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#6A44B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#7953B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#A27ACD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A880D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint238_linear_3875_2346",
    x1: 177.482,
    y1: 213.719,
    x2: 180.19,
    y2: 213.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#C4509F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#D15FA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#F288B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF97C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint239_linear_3875_2346",
    x1: 218,
    y1: 236.995,
    x2: 224.741,
    y2: 236.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#6A44B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#7953B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#A27ACD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A880D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint240_linear_3875_2346",
    x1: 189.042,
    y1: 220.36,
    x2: 216.851,
    y2: 220.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#6A44B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#7953B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#A27ACD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A880D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint241_linear_3875_2346",
    x1: 173.332,
    y1: 211.335,
    x2: 176.333,
    y2: 211.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#6A44B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#7953B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#A27ACD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A880D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint242_linear_3875_2346",
    x1: 181.327,
    y1: 223.921,
    x2: 184.047,
    y2: 223.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#703FB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#7F4DB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#A872CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B37DD0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint243_linear_3875_2346",
    x1: 185.184,
    y1: 226.137,
    x2: 187.893,
    y2: 226.137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#703FB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#7F4DB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#A872CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B37DD0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint244_linear_3875_2346",
    x1: 177.482,
    y1: 221.712,
    x2: 180.19,
    y2: 221.712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#BF49A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#CD58A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#F081BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF91C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint245_linear_3875_2346",
    x1: 218,
    y1: 244.973,
    x2: 224.741,
    y2: 244.973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#703FB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#7F4DB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#A872CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B37DD0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint246_linear_3875_2346",
    x1: 189.042,
    y1: 228.353,
    x2: 216.851,
    y2: 228.353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#703FB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#7F4DB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#A872CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B37DD0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint247_linear_3875_2346",
    x1: 173.332,
    y1: 219.313,
    x2: 176.333,
    y2: 219.313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#703FB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#7F4DB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#A872CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B37DD0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint248_linear_3875_2346",
    x1: 181.327,
    y1: 231.899,
    x2: 184.047,
    y2: 231.899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#773AB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#8648B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#AF6BC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE79D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint249_linear_3875_2346",
    x1: 185.184,
    y1: 234.115,
    x2: 187.893,
    y2: 234.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#773AB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#8648B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#AF6BC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE79D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint250_linear_3875_2346",
    x1: 177.482,
    y1: 229.69,
    x2: 180.19,
    y2: 229.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#BA42A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#C951A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#EF7ABB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8AC3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint251_linear_3875_2346",
    x1: 218,
    y1: 252.966,
    x2: 224.741,
    y2: 252.966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#773AB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#8648B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#AF6BC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE79D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint252_linear_3875_2346",
    x1: 189.042,
    y1: 236.33,
    x2: 216.851,
    y2: 236.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#773AB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#8648B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#AF6BC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE79D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint253_linear_3875_2346",
    x1: 173.332,
    y1: 227.306,
    x2: 176.333,
    y2: 227.306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#773AB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#8648B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#AF6BC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE79D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint254_linear_3875_2346",
    x1: 181.327,
    y1: 239.876,
    x2: 184.047,
    y2: 239.876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#7E34AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#8D41B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#B664C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C975CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint255_linear_3875_2346",
    x1: 185.184,
    y1: 242.092,
    x2: 187.893,
    y2: 242.092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#7E34AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#8D41B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#B664C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C975CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint256_linear_3875_2346",
    x1: 177.482,
    y1: 237.667,
    x2: 180.19,
    y2: 237.667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#B63BA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#C54AAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#EE73BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF84C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint257_linear_3875_2346",
    x1: 218,
    y1: 260.943,
    x2: 224.741,
    y2: 260.943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#7E34AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#8D41B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#B664C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C975CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint258_linear_3875_2346",
    x1: 189.042,
    y1: 244.308,
    x2: 216.851,
    y2: 244.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#7E34AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#8D41B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#B664C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C975CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint259_linear_3875_2346",
    x1: 173.332,
    y1: 235.283,
    x2: 176.333,
    y2: 235.283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#7E34AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#8D41B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#B664C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C975CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint260_linear_3875_2346",
    x1: 181.327,
    y1: 247.854,
    x2: 184.047,
    y2: 247.854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#842FAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#933CB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#BC5EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D472CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint261_linear_3875_2346",
    x1: 185.184,
    y1: 250.07,
    x2: 187.893,
    y2: 250.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#842FAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#933CB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#BC5EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D472CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint262_linear_3875_2346",
    x1: 177.482,
    y1: 245.645,
    x2: 180.19,
    y2: 245.645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#B134A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#C042AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#E968BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7DC7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint263_linear_3875_2346",
    x1: 218,
    y1: 268.921,
    x2: 224.741,
    y2: 268.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#842FAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#933CB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#BC5EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D472CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint264_linear_3875_2346",
    x1: 189.042,
    y1: 252.286,
    x2: 216.851,
    y2: 252.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#842FAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#933CB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#BC5EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D472CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint265_linear_3875_2346",
    x1: 173.332,
    y1: 243.261,
    x2: 176.333,
    y2: 243.261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#842FAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#933CB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#BC5EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D472CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint266_linear_3875_2346",
    x1: 181.327,
    y1: 255.847,
    x2: 184.047,
    y2: 255.847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#8B29AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#9A36B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#C357C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE6ECF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint267_linear_3875_2346",
    x1: 185.184,
    y1: 258.063,
    x2: 187.893,
    y2: 258.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#8B29AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#9A36B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#C357C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE6ECF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint268_linear_3875_2346",
    x1: 177.482,
    y1: 253.638,
    x2: 180.19,
    y2: 253.638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#AD2EA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#BC3CAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#E55FBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF77C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint269_linear_3875_2346",
    x1: 218,
    y1: 276.914,
    x2: 224.741,
    y2: 276.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#8B29AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#9A36B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#C357C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE6ECF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint270_linear_3875_2346",
    x1: 189.042,
    y1: 260.279,
    x2: 216.851,
    y2: 260.279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#8B29AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#9A36B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#C357C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE6ECF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint271_linear_3875_2346",
    x1: 173.332,
    y1: 251.254,
    x2: 176.333,
    y2: 251.254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#8B29AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#9A36B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#C357C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE6ECF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint272_linear_3875_2346",
    x1: 181.327,
    y1: 263.825,
    x2: 184.047,
    y2: 263.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9224AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#A130B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#CA51C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E96ACF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint273_linear_3875_2346",
    x1: 185.184,
    y1: 266.04,
    x2: 187.893,
    y2: 266.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9224AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#A130B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#CA51C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E96ACF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint274_linear_3875_2346",
    x1: 177.482,
    y1: 261.615,
    x2: 180.19,
    y2: 261.615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#A827A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#B734AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E056BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF70CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint275_linear_3875_2346",
    x1: 218,
    y1: 284.891,
    x2: 224.741,
    y2: 284.891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9224AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#A130B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#CA51C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E96ACF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint276_linear_3875_2346",
    x1: 189.042,
    y1: 268.256,
    x2: 216.851,
    y2: 268.256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9224AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#A130B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#CA51C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E96ACF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint277_linear_3875_2346",
    x1: 173.332,
    y1: 259.231,
    x2: 176.333,
    y2: 259.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9224AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#A130B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#CA51C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E96ACF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint278_linear_3875_2346",
    x1: 181.327,
    y1: 271.802,
    x2: 184.047,
    y2: 271.802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#981EAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A72AB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#D04AC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F467CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint279_linear_3875_2346",
    x1: 185.184,
    y1: 274.018,
    x2: 187.893,
    y2: 274.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#981EAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A72AB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#D04AC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F467CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint280_linear_3875_2346",
    x1: 177.482,
    y1: 269.593,
    x2: 180.19,
    y2: 269.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#A420AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#B32DB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#DC4DBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6ACC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint281_linear_3875_2346",
    x1: 218,
    y1: 292.869,
    x2: 224.741,
    y2: 292.869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#981EAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A72AB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#D04AC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F467CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint282_linear_3875_2346",
    x1: 189.042,
    y1: 276.234,
    x2: 216.851,
    y2: 276.234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#981EAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A72AB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#D04AC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F467CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint283_linear_3875_2346",
    x1: 173.332,
    y1: 267.209,
    x2: 176.333,
    y2: 267.209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#981EAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A72AB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#D04AC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F467CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint284_linear_3875_2346",
    x1: 181.327,
    y1: 279.795,
    x2: 184.047,
    y2: 279.795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D744BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint285_linear_3875_2346",
    x1: 185.184,
    y1: 282.011,
    x2: 187.893,
    y2: 282.011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D744BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint286_linear_3875_2346",
    x1: 177.482,
    y1: 277.586,
    x2: 180.19,
    y2: 277.586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D744BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint287_linear_3875_2346",
    x1: 218,
    y1: 300.862,
    x2: 224.741,
    y2: 300.862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D744BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint288_linear_3875_2346",
    x1: 189.042,
    y1: 284.227,
    x2: 216.851,
    y2: 284.227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D744BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint289_linear_3875_2346",
    x1: 173.332,
    y1: 275.202,
    x2: 176.333,
    y2: 275.202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D744BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint290_linear_3875_2346",
    x1: 168.567,
    y1: 216.111,
    x2: 221.001,
    y2: 216.111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#138BBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#169AC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1FC3DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint291_linear_3875_2346",
    x1: 40.8717,
    y1: 250.594,
    x2: 355.516,
    y2: 180.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint292_linear_3875_2346",
    x1: 228.386,
    y1: 315.249,
    x2: 160.548,
    y2: 114.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#972A74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#8A266A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#601B4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3D112F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#230A1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0F040C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#040103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint293_linear_3875_2346",
    x1: 188.202,
    y1: 84.0117,
    x2: 196.011,
    y2: 161.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#972A74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#8A266A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#601B4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3D112F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#230A1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0F040C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#040103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint294_linear_3875_2346",
    x1: 225.247,
    y1: 369.21,
    x2: 137.479,
    y2: 369.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A31CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#C234B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#DC48C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FF63CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#ED55C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#E04BC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#DC48C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint295_linear_3875_2346",
    x1: 232.469,
    y1: 258.029,
    x2: 174.536,
    y2: 368.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D744BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint296_radial_3875_2346",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(177.259 367.405) scale(24.6875 24.6768)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint297_linear_3875_2346",
    x1: 225.246,
    y1: 374.18,
    x2: 137.479,
    y2: 374.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A31CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#C234B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#DC48C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FF63CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#ED55C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#E04BC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#DC48C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint298_linear_3875_2346",
    x1: 161.614,
    y1: 323.776,
    x2: 206.621,
    y2: 333.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C8ABDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#DAC6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F7F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F9F5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E8DBEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D5BFE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#C7AFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#B397DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#A788DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A383DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#AE8DDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8A6DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint299_linear_3875_2346",
    x1: 162.625,
    y1: 279.837,
    x2: 187.941,
    y2: 292.507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D744BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint300_linear_3875_2346",
    x1: 157.518,
    y1: 346.297,
    x2: 201.824,
    y2: 355.613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C211A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C518A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#CE2DAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#CF30B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FF63CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#EB48BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#C211A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#A919AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#AC18AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B715A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C211A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint301_linear_3875_2346",
    x1: 162.813,
    y1: 321.109,
    x2: 207.12,
    y2: 330.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C211A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C518A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#CE2DAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#CF30B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FF63CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#EB48BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#C211A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#A919AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#AC18AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B715A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C211A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint302_linear_3875_2346",
    x1: 168.163,
    y1: 295.718,
    x2: 212.456,
    y2: 305.033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C211A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C518A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#CE2DAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#CF30B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FF63CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#EB48BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#C211A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#A919AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#AC18AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B715A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C211A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint303_linear_3875_2346",
    x1: 188.66,
    y1: 289.198,
    x2: 173.284,
    y2: 289.198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#D744BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF63CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#DC48C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint304_linear_3875_2346",
    x1: 181.895,
    y1: 286.451,
    x2: 181.895,
    y2: 312.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint305_radial_3875_2346",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(204.072 319.186) rotate(-10.6152) scale(8.21742 25.1848)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#0D043D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#070222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#03010F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#010004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint306_radial_3875_2346",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(232.861 366.014) rotate(-169.385) scale(8.21742 25.1848)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#972A74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#8A266A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#601B4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3D112F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#230A1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0F040C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#040103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint307_linear_3875_2346",
    x1: 77.4718,
    y1: 305.982,
    x2: 53.3069,
    y2: 281.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#4A4A54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#D4D1D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint308_linear_3875_2346",
    x1: 49.8467,
    y1: 302.359,
    x2: 81.985,
    y2: 295.146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#4A4A54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#D4D1D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint309_linear_3875_2346",
    x1: 20.348,
    y1: 338.161,
    x2: -9.62725,
    y2: 317.837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#4A4A54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#D4D1D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint310_linear_3875_2346",
    x1: -9.00187,
    y1: 337.677,
    x2: 22.7052,
    y2: 330.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#4A4A54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#D4D1D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint311_linear_3875_2346",
    x1: 34.3765,
    y1: 237.42,
    x2: 264.527,
    y2: 255.539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9D9EB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D4D1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEBF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint312_linear_3875_2346",
    x1: 34.0802,
    y1: 244.317,
    x2: 76.5,
    y2: 234.813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9D9EB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D4D1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEBF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint313_linear_3875_2346",
    x1: 32.8132,
    y1: 257.369,
    x2: 262.964,
    y2: 275.502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9D9EB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D4D1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEBF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint314_linear_3875_2346",
    x1: -98.8174,
    y1: 285.144,
    x2: 154.327,
    y2: 228.376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9D9EB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D4D1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEBF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint315_linear_3875_2346",
    x1: 58.3095,
    y1: 167.592,
    x2: 49.435,
    y2: 184.514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9D9EB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D4D1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEBF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint316_linear_3875_2346",
    x1: -71.9718,
    y1: 341.457,
    x2: 243.617,
    y2: 323.253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9D9EB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D4D1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEBF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint317_linear_3875_2346",
    x1: 75.0471,
    y1: 297.11,
    x2: 66.7306,
    y2: 313.899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9D9EB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D4D1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEBF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint318_linear_3875_2346",
    x1: 111.013,
    y1: 274.866,
    x2: 358.199,
    y2: 337.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9D9EB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D4D1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEBF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint319_linear_3875_2346",
    x1: 106.175,
    y1: 285.521,
    x2: 148.581,
    y2: 276.017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9D9EB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D4D1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEBF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint320_linear_3875_2346",
    x1: 130.404,
    y1: 208.783,
    x2: 121.516,
    y2: 225.718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9D9EB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D4D1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEBF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint321_linear_3875_2346",
    x1: 105.043,
    y1: 298.587,
    x2: 352.229,
    y2: 360.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9D9EB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D4D1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEBF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint322_linear_3875_2346",
    x1: -26.7222,
    y1: 326.348,
    x2: 226.422,
    y2: 269.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9D9EB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D4D1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEBF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint323_linear_3875_2346",
    x1: 130.404,
    y1: 208.783,
    x2: 121.516,
    y2: 225.718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9D9EB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D4D1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEBF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint324_linear_3875_2346",
    x1: 149.405,
    y1: 347.065,
    x2: 125.24,
    y2: 322.553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#4A4A54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#D4D1D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint325_linear_3875_2346",
    x1: 121.766,
    y1: 343.442,
    x2: 153.905,
    y2: 336.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#4A4A54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#D4D1D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint326_linear_3875_2346",
    x1: 92.2819,
    y1: 379.245,
    x2: 62.3066,
    y2: 358.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#4A4A54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#D4D1D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint327_linear_3875_2346",
    x1: 62.9183,
    y1: 378.76,
    x2: 94.6387,
    y2: 371.642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#4A4A54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#D4D1D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint328_linear_3875_2346",
    x1: 93.0631,
    y1: 320.543,
    x2: 71.7592,
    y2: 278.644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9D9EB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D4D1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEBF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint329_linear_3875_2346",
    x1: -116.731,
    y1: 228.948,
    x2: 207.429,
    y2: 146.915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9D9EB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D4D1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEBF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint330_linear_3875_2346",
    x1: 41.3518,
    y1: 176.733,
    x2: 96.9938,
    y2: 283.087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9D9EB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D4D1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEBF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint331_linear_3875_2346",
    x1: -105.285,
    y1: 191.1,
    x2: 218.875,
    y2: 109.067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9D9EB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D4D1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEBF2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint332_radial_3875_2346",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113.816 262.393) scale(27.76 27.748)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint333_radial_3875_2346",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(118.788 229.783) scale(29.9969 29.984)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint334_linear_3875_2346",
    x1: -7.08826,
    y1: 251.308,
    x2: 125.364,
    y2: 249.838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FFA98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFB892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FEE1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEECA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint335_linear_3875_2346",
    x1: 23.3802,
    y1: 248.425,
    x2: 118.047,
    y2: 252.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint336_radial_3875_2346",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(83.6304 239.239) scale(23.313 23.3029)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint337_linear_3875_2346",
    x1: 24.3102,
    y1: 228.18,
    x2: 118.977,
    y2: 232.561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint338_linear_3875_2346",
    x1: 23.9461,
    y1: 235.965,
    x2: 118.613,
    y2: 240.347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint339_linear_3875_2346",
    x1: 23.6636,
    y1: 242.229,
    x2: 118.33,
    y2: 246.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint340_linear_3875_2346",
    x1: 23.3131,
    y1: 249.691,
    x2: 117.98,
    y2: 254.073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint341_linear_3875_2346",
    x1: 23.0164,
    y1: 256.197,
    x2: 117.683,
    y2: 260.579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint342_linear_3875_2346",
    x1: 23.5285,
    y1: 245.031,
    x2: 118.195,
    y2: 249.412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint343_linear_3875_2346",
    x1: 23.394,
    y1: 248.115,
    x2: 118.047,
    y2: 252.497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint344_linear_3875_2346",
    x1: 23.2456,
    y1: 251.254,
    x2: 117.913,
    y2: 255.635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint345_linear_3875_2346",
    x1: 23.0977,
    y1: 254.325,
    x2: 117.777,
    y2: 258.706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint346_linear_3875_2346",
    x1: 23.0032,
    y1: 256.561,
    x2: 117.669,
    y2: 260.942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint347_linear_3875_2346",
    x1: 22.8414,
    y1: 259.996,
    x2: 117.508,
    y2: 264.377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint348_linear_3875_2346",
    x1: 22.7199,
    y1: 262.69,
    x2: 117.373,
    y2: 267.071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint349_linear_3875_2346",
    x1: 22.5582,
    y1: 266.205,
    x2: 117.212,
    y2: 270.587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint350_linear_3875_2346",
    x1: 22.4369,
    y1: 268.576,
    x2: 117.104,
    y2: 272.958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint351_linear_3875_2346",
    x1: 22.3158,
    y1: 271.054,
    x2: 116.996,
    y2: 275.436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint352_linear_3875_2346",
    x1: 22.2214,
    y1: 273.291,
    x2: 116.888,
    y2: 277.672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint353_linear_3875_2346",
    x1: 22.0867,
    y1: 276.429,
    x2: 116.74,
    y2: 280.811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint354_linear_3875_2346",
    x1: -49.9677,
    y1: 226.2,
    x2: 358.532,
    y2: 134.583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D744BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint355_linear_3875_2346",
    x1: -24.9435,
    y1: 217.781,
    x2: 326.758,
    y2: 138.917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#B5B4C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#CBCAD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#E7E7EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#F9F9FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint356_linear_3875_2346",
    x1: 242.104,
    y1: 186.975,
    x2: 526.044,
    y2: 101.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D744BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint357_linear_3875_2346",
    x1: 243.708,
    y1: 185.669,
    x2: 523.161,
    y2: 101.955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#B5B4C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#CBCAD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#E7E7EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#F9F9FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint358_linear_3875_2346",
    x1: -72.7689,
    y1: 177.18,
    x2: 372.455,
    y2: 79.7337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D744BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint359_linear_3875_2346",
    x1: -72.7691,
    y1: 177.166,
    x2: 372.455,
    y2: 79.7202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#B5B4C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#CBCAD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#E7E7EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#F9F9FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint360_linear_3875_2346",
    x1: 253.829,
    y1: 202.601,
    x2: 460.235,
    y2: 140.765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D744BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint361_linear_3875_2346",
    x1: 253.829,
    y1: 202.574,
    x2: 460.208,
    y2: 140.752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#B5B4C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#CBCAD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#E7E7EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#F9F9FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3875_2346"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 342,
    height: 388,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComingSoon);
export default __webpack_public_path__ + "static/media/ComingSoon.e2f8d3eb99cc2a27185bcd9eaa002fc4.svg";
export { ForwardRef as ReactComponent };